import React from "react";
import moment from "moment";
import { message } from "antd";
import { HABIDO } from '../../../common/types/condicionSunatType';
import { ACTIVO } from '../../../common/types/estadoContribuyenteType';
import { JURIFICA, NATURAL } from '../../../common/types/tipoPersonaType';
import { RUC, OTROS, DNI, CARNET_EXTRANJERIA, PASAPORTE } from '../../../common/types/tipoDocumentoType';
import { DOMICILIO_FISCAL } from '../../../common/types/tipoEstablecimientoType';
import PaginationBase from "../../../common/base/PaginationBase";
import usuarioService from '../../../service/seguridad/usuarioService';
import { lst_tipo_impuesto } from "../../../common/types/impuestoType";
import { lst_tipo_afectacion } from "../../../common/types/tipoAfectacion";

import {
  VENTAS_COTIZACION,
  VENTAS_PEDIDO,
  VENTAS_GUIA_REMISION,
} from "../../../common/types/referenciaOrigenType";
import { PAGINATION, FILTER } from "../../../common/types/paginationType";
import {
  BOLETA_DE_VENTA,
  GUIA_REMISION_REMITENTE,
} from "../../../common/types/tipoComprobanteType";
import { SOLES, DOLARES_AMERICANOS } from "../../../common/types/monedaType";
import { CLIENTE_VARIOS } from "../../../common/types/clienteType";
import {
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
  IMPORTAR_GRE,
  VENTA_MODIFICAR_TOTAL_PRODUCTO,
  VENTA_VALIDAR_TOPE_MAXIMO_VENTAS_SOLES,
  VALIDAR_STOCK,
  VENTA_VISUALIZACION_DOCUMENTOS,
  VENTA_BLOQUEAR_IMPUESTOS,
  IMPUESTO_PROMOCION_MUNICIPAL,
  VENTA_GUIA_REMISION_GENERA_SALIDAS,
  CONVERSION_MEDIDA,
  CONTROL_COMPBANTE,
  LOGISTICA_PRODUCTOS_CON_LOTE
} from "../../../common/types/parametroType";
import printFormatMock from "../../../common/mock/printFormatMock";

import dialog from "../../../common/utility/dialog";
import global from "../../../common/utility/global";
import auth from "../../../common/utility/auth";
import { lst_pendiente_pagos } from "../../../common/types/pendientePagoType";

import { CONTADO, CREDITO } from "../../../common/types/formaPagoType";
import comprobanteService from "../../../service/ventas/comprobanteService";
/* import monedaService from "../../../service/administracion/monedaService";
import listaPrecioService from "../../../service/administracion/listaPrecioService";
import vendedorService from "../../../service/administracion/vendedorService";
 */
import tipoComprobanteService from "../../../service/administracion/tipoComprobanteService";
import detraccionService from "../../../service/administracion/detraccionService";
import unidadMedidaService from '../../../service/administracion/unidadMedidaService';

import tipoCambioDiarioService from "../../../service/administracion/tipoCambioDiarioService";
import establecimientoService from "../../../service/administracion/establecimientoService";
import almacenService from "../../../service/administracion/almacenService";
import padronReducidoService from "../../../service/integracion/padronReducidoService";
import productoService from "../../../service/administracion/productoService";
import clienteService from "../../../service/administracion/clienteService";
import pedidoService from "../../../service/ventas/pedidoService";
import cotizacionService from "../../../service/ventas/cotizacionService";
import guiaRemisionService from "../../../service/logistica/guiaRemisionService";
import movimientoService from "../../../service/logistica/movimientoService";
/* import tipoPersonaService from '../../../service/administracion/tipoPersonaService';
import tipoDocumentoService from '../../../service/administracion/tipoDocumentoService';
import condicionSunatService from '../../../service/administracion/condicionSunatService';
import estadoContribuyenteService from '../../../service/administracion/estadoContribuyenteService';
import tipoRelacionService from '../../../service/administracion/tipoRelacionService';
import tipoEstablecimientoService from '../../../service/administracion/tipoEstablecimientoService';
import paisService from '../../../service/administracion/paisService';
import metodoPagoservice from '../../../service/administracion/metodoPagoService';
import cuentaService from '../../../service/administracion/cuentaService'; */
import vehiculoService from '../../../service/logistica/vehiculoService';
import proyectoService from '../../../service/administracion/proyectoService';
import ubigeoService from '../../../service/integracion/ubigeoService';
import fenologicaService from '../../../service/administracion/fenologicaService';
import hubService from '../../../service/hub/hubService';

import ventasService from '../../../service/ventas/ventasService';
import cajaService from '../../../service/administracion/cajaService';

import Header from "../../../components/Header";
import Filters from "../Comprobante/Filters";
import SearchProductModal from "../../../components/SearchProductModal";
import FormModalCliente from '../../../modules/administracion/Cliente/FormModal';
import ResultList from "../Comprobante/ResultList";
import FormModal from "../Comprobante/FormModal";
import EditarNombreProductoModal from "../Comprobante/EditarNombreProductoModal";
import EmitirModal from "../Comprobante/EmitirModal";
import ImprimirModal from "../Comprobante/ImprimirModal";
import CdrModal from "../Comprobante/CdrModal";
import CorreoModal from "../Comprobante/CorreoModal";
import ViewModal from "../Comprobante/ViewModal";
import ImportarModal from "../Comprobante/ImportarModal";
import ImportarModalCotizacion from "../Comprobante/ImportarModalCotizacion";
import ImportarModalAnticipo from '../Comprobante/ImportarModalAnticipo';
import ImportarModalGuia from '../Comprobante/ImportarModalGuia';
import AgregarSerieModal from "../Comprobante/AgregarSerieModal";

import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';

import { VENTA } from '../../../common/types/moduloType';
import { EMISION_AUTO, CREAR_COPIAR_COMPRO, EMISION_COMPRO, EDITAR_COMPRO, EDITAR_PRECIO_VENTA, VER_SERIES_VENTA, PUNTO_VENTA_COBRANZA } from '../../../common/types/configuracionType';
import paisService from "../../../service/administracion/paisService";

export default class Index extends PaginationBase {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.props.onSetBreadcrumb();
    this.state = {
      loadingEdit: true,
      loadingCopy: false,
      loadingNew: false,
      loadingSource: true,
      loadingProduct: false,
      saveLoading: false,
      isPendienteSi: true,
      loadingFile: false,
      importarAnticipoVisible: false,
      monedas: [],
      tiposCambioDiario: [],
      listasPrecio: [],
      establecimientos: [],
      almacenes: [],
      vendedores: [],
      clientes: [],
      direcciones: [],
      tiposComprobante: [],
      productos: [],
      detracciones: [],
      pendientePago: lst_pendiente_pagos,
      metodosPagos: [],
      cuentas: [],
      estado: [],
      unidadesMedida: [],
      permisosUsuario: [],
      proyectos: [],
      configuraciones: [],
      totaldocument: [],
      cultivos: [],
      company: {},
      filter: {
        idTipoComprobante: BOLETA_DE_VENTA.ID,
        fechaInicioStr: global.fetchCurrentDateStr(true),
        fechaFinStr: global.fetchCurrentDateStr(),
        serie: "",
        documento: "",
        vehiculo: "",
        idEstado: 0,
        idProyecto: 0,
        cliente: "",
        ...FILTER,
      },
      pagination: PAGINATION,
      visible: false,
      formValues: this.fetchEmptyFormValues(),
      productoModal: {
        nombre: "",
        dataSource: [],
      },
      editarNombreProductoFormValues: {
        id: "",
        nombre: "",
      },
      importarCotizacionFormValues: {
        nombre: "",
        dataSource: [],
        selectedRowKeys: [],
      },
      onSetFieldsValue: null,
      onGetFieldValue: null,
      searchProductVisible: false,
      searchProductFormValues: {
        validarStock: false,
        precioUnitInclyIGV: false,
        dataSource: [],
      },
      emitirVisible: false,
      emitirFilePdf: undefined,
      imprimirVisible: false,
      imprimirFormValues: {
        file: undefined,
        idComprobante: 0,
        idFormato: 0,
        isEpson: false,
        formatos: printFormatMock.values,
      },
      correoFormValues: {
        file: undefined,
        idComprobante: 0,
        idFormato: 0,
        correoCliente: "",
        formatos: printFormatMock.values,
      },
      cdrVisible: false,
      selectedItem: {},
      viewVisible: false,
      viewFormValues: {},
      importarFormValues: {
        nombre: "",
        dataSource: [],
        selectedRowKeys: [],
      },
      importarGuiaRemision: {
        nombre: "",
        dataSource: [],
        selectedRowKeys: [],
      },
      importarAnticipo: {
        nombre: "",
        dataSource: [],
        selectedRowKeys: [],
      },
      agregarSerieModal: {
        serie: '',
        idProducto: 0,
        listaDetalleSerie: [],
        selectedRowKeys: []
      },
      /*CLIENTE */
      tiposPersona: [],
      tiposDocumento: [],
      condicionesSunat: [],
      estadosContribuyente: [],
      tiposEstablecimiento: [],
      tiposRelacion: [],
      vendedores: [],
      departamentos: [],
      provincias: [],
      distritos: [],
      paises: [],
      caja: [],
      visibleCliente: false,
      formValuesCliente: this.fetchEmptyFormValuesCliente()
    };
  }

  fetchEmptyFormValues = () => {
    return {
      id: 0,
      idMovimiento: 0,
      idTipoComprobante: BOLETA_DE_VENTA.ID,
      idCliente: 0,
      idEstablecimientoCliente: 0,
      flagGuiaRemisionGeneraSalidas: false,
      isImportando: false,
      idVendedor: 0,
      idAlmacen: 0,
      idMoneda: SOLES,
      idListaPrecio: 0,
      idVehiculo: 0,
      encargado: '',
      // idComprobanteEstado: 0,
      idFormaPago: CONTADO,
      idEstablecimiento: 0,
      idDetraccion: 0,
      idProyecto: 0,
      idUsuarioRegistro: auth.user().id,
      serie: "",
      documento: "",
      fechaStr: global.fetchCurrentDateStr(),
      fechaVencimientoStr: global.fetchCurrentDateStr(),
      diasVencimiento: 0,
      numeroPlaca: "",
      tipoCambio: 0,
      observacion: "",
      giroNegocio: "",
      idMedidaAnticipo: 2,
      flagExportacion: false,
      flagPercepcion: false,
      flagDetraccion: false,
      flagPago: false,
      // flagAnticipo: false,
      flagAnticipo: false,
      flagRegularizacion: false,
      totalAnticipo: 0,
      flagDescuentoGlobal: false,
      flagDocumentoEnviado: false,
      flagGrifo: false,
      flagGiroNegocio: false,
      listaComprobanteDetalle: [],
      listaComprobanteReferencia: [],
      listaComprobanteCuota: [],
      listaComprobanteMetodoPago: [],
      metodosPagos: [],
      cuentas: [],
      cultivos: [],
      fenologicas: [],
      /*********************/
      sumaTotalDetalle: 0,
      sumaImporteDescuento: 0,
      sumaSubTotal: 0,
      sumaIgv: 0,
      sumaIsc: 0,
      sumaTotal: 0,
      idPendiente: auth.user().planCode == "PLA003" ? 1 : 2,
      porcentajeDescuentoGlobal: 0,
      importeDescuentoGlobal: 0,
      porcentajeDetraccion: 0,
      importeDetraccion: 0,
      totalDetraccion: 0,
      porcentajePercepcion: 0,
      importePercepcion: 0,
      totalPercepcion: 0,
      flagTipoBusquedaScanner: 0,
      precioUnitarioDetailDisabled: false,
      flagCobranzaDirecta: false,
      totalDetailDisabled:
        auth
          .user()
          .parametros.filter(
            (m) => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO
          )[0].valor === "1"
          ? false
          : true,
      flagEmpresaGrifo: false,
      flagImpuesto: auth.user().parametros.filter(m => m.abreviatura === VENTA_BLOQUEAR_IMPUESTOS)[0].valor === "1" ? true : false,
      flagEmpresaTaller: false,
      otroImpuesto: 1,// auth.user().parametros.filter(m => m.abreviatura === IMPUESTO_PROMOCION_MUNICIPAL)[0].valor === "1" ? 2 : 1,

      almacenLoading: false,
      clienteLoading: false,
      activeKey: "1",
      documentoCliente: "",
      monedas: [],
      listasPrecio: [],
      establecimientos: [],
      almacenes: [],
      vendedores: [],
      clientes: [],
      direcciones: [],
      tiposComprobante: [],
      detracciones: [],
      detalleProductos: [],
      vehiculos: [],
      flagDisableSerieDocumento: true,
      flagDisableFecha: auth.user().parametros.filter((m) => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false,
      flagContingencia: false,
      pendientePago: [],
      caja: [],
      unidadesMedida: [],
      Tipoimpuesto: lst_tipo_impuesto,
      proyectos: [],
      idTipoPrecio: [],
      flagAmazonia: false,
      flagAmazoniaServicio: false,
      flagAmazoniaBien: false,
      flagClaim: false,
      nroOrden: '',
      idCultivo: 0,
      idFenologica: 0,

      sumaExonerada: 0,
      sumaInafecta: 0,
      sumaGratuita: 0,

    };
  };

  handleClearFilters = () => {
    var filter = {
      idTipoComprobante: BOLETA_DE_VENTA.ID,
      fechaInicioStr: global.fetchCurrentDateStr(true),
      fechaFinStr: global.fetchCurrentDateStr(),
      serie: this.state.filter.serie,
      documento: "",
      vehiculo: '',
      idProyecto: 0,
      cliente: "",
      ...FILTER,
    };
    this.setState({ filter });
    this._handlePagination(filter);
  };

  handleKeyUpInput = (e) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      const filter = { ...this.state.filter, ...FILTER };
      this._handlePagination(filter);
    }
  };

  handleChange = (property, value) => {
    const filter = { ...this.state.filter, [property]: value };
    this.setState({ filter });
  };

  handleExportExcel = async () => {
    this.setState({ loadingExcel: true });
    var response = await comprobanteService.excel(this.state.filter);
    this.setState({ loadingExcel: false });
    if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Boletas.xlsx");
  };

  handleExportPdf = async () => {
    this.setState({ loadingImprimir: true });
    var response = await comprobanteService.pdf(this.state.filter);
    this.setState({ loadingImprimir: false });
    if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Boletas.pdf");
  };

  handlePrint = async () => {
    this.setState({ loadingPrint: true });
    var response = await comprobanteService.pdf(this.state.filter);
    this.setState({ loadingPrint: false });
    if (response !== undefined) {
      var file = window.URL.createObjectURL(response.data);
      var win = window.open(file, "_blank");
      win.focus();
    }
  };
  /******************** FORM MODAL *****************/

  handleNew = async () => {

    var flagCrear = this.state.configuraciones.filter((m) => m.abreviatura === CREAR_COPIAR_COMPRO).length >= 1 ? true : false;
    var flagPrecioEditar = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_PRECIO_VENTA).length >= 1 ? false : true;
    var flagCobranzaDirecta = this.state.configuraciones.filter((m) => m.abreviatura === PUNTO_VENTA_COBRANZA).length >= 1 ? true : false;
    var params = auth.user().parametros;

    if (!flagCrear) {
      message.warning('Usted no puede crear comprobantes.');
      return;
    }


    var controlDcumento = params.filter((m) => m.abreviatura === CONTROL_COMPBANTE)[0].valor === "1" ? true : false;
    if (controlDcumento) {
      if (this.state.totaldocument[0].total > auth.user().totalDocumentos) {
        message.error('Usted no puede crear comprobantes. ya supero la cantidad contratada');
        return;
      }
    }

    this.setState({ loadingNew: true });

    const clientes = await clienteService.getByComprobante({
      id: CLIENTE_VARIOS,
      value: '',
      type: [OTROS.CODIGO, DNI.CODIGO, CARNET_EXTRANJERIA.CODIGO, RUC.CODIGO, PASAPORTE.CODIGO].join(',')
    });

    //const clientes = await clienteService.listar();
    var paramGuiaRemisionGeneraSalidas = params.filter((m) => m.abreviatura === VENTA_GUIA_REMISION_GENERA_SALIDAS)[0].valor === "1" ? true : false;
    var importarGuia = params.filter((m) => m.abreviatura === IMPORTAR_GRE)[0].valor === "1" ? true : false;

    var formValues = this.fetchEmptyFormValues();
    formValues.flagGuiaRemisionGeneraSalidas = paramGuiaRemisionGeneraSalidas;
    formValues.flagGuiaImportar = importarGuia;
    formValues.monedas = this.state.monedas;
    formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
    formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;
    formValues.vendedores = this.state.vendedores;
    formValues.tiposComprobante = this.state.tiposComprobante.length === 0 ? await tipoComprobanteService.listar() : this.state.tiposComprobante;
    formValues.detracciones = this.state.detracciones.length === 0 ? await detraccionService.listar() : this.state.detracciones;
    formValues.clientes = clientes;
    formValues.pendientePago = this.state.pendientePago;
    formValues.metodosPagos = this.state.metodosPagos;
    formValues.cuentas = this.state.cuentas.filter(e => e.idMoneda == SOLES);
    formValues.caja = this.state.caja;
    formValues.unidadesMedida = this.state.unidadesMedida.length === 0 ? await unidadMedidaService.listar() : this.state.unidadesMedida;
    formValues.proyectos = this.state.proyectos;
    formValues.precioUnitarioDetailDisabled = flagPrecioEditar;
    formValues.flagCobranzaDirecta = auth.user().planCode == "PLA003" ? flagCobranzaDirecta : false;
    formValues.cultivos = this.state.cultivos;
    formValues.otroImpuesto = this.state.company.idTipoImpuesto;
    formValues.flagGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
    formValues.flagEmpresaGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
    formValues.flagClaim = this.state.company.idTipoEmpresa == 2 ? true : false;
    formValues.flagEmpresaTaller = this.state.company?.idTipoEmpresa === 5;
    formValues.flagGiroNegocio = this.state.company?.idTipoEmpresa === 4;
    formValues.tipoAfectacion = lst_tipo_afectacion;


    var cliente_varios = formValues.clientes.filter((m) => m.id === CLIENTE_VARIOS);
    if (cliente_varios.length !== 0) {
      formValues.idCliente = CLIENTE_VARIOS;
      const direcciones = await establecimientoService.listarPorIdEntidad(
        cliente_varios[0].idEntidad
      );
      formValues.documentoCliente = cliente_varios[0].numeroDocumento;
      formValues.direcciones = direcciones ? direcciones : [];
      formValues.idEstablecimientoCliente =
        direcciones.length > 0 ? direcciones[0].id : undefined;
      formValues.direccionCliente =
        direcciones.length > 0 ? direcciones[0].direccion : "";
    }

    // const productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
    const datosIniciales = await comprobanteService.datosIniciales({
      idUsuario: auth.user().id,
      idTipoComprobante: BOLETA_DE_VENTA.ID,
    });
    if (datosIniciales !== undefined) {
      formValues.fechaStr = datosIniciales.fechaStr;
      formValues.fechaVencimientoStr = datosIniciales.fechaStr;
      formValues.serie = datosIniciales.serie;
      formValues.idVendedor = datosIniciales.idVendedor;
      formValues.idAlmacen = datosIniciales.idAlmacen;
      formValues.idListaPrecio = datosIniciales.idListaPrecio;
      formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
      //formValues.idCaja = datosIniciales.idCaja;

      var _amazonia = formValues.establecimientos.filter(data => data.id == datosIniciales.idEstablecimiento);
      formValues.flagAmazonia = _amazonia.length > 0 ? _amazonia[0].flagAmazonia : false;

    }



    if (formValues.idEstablecimiento > 0) {
      const almacenes = await await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);

      var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);
      if (almacenFilter != undefined && this.state.permisosUsuario.length > 0) {
        var esta = formValues.establecimientos.filter(data => data.id == formValues.idEstablecimiento);
        var newArray = new Array();
        this.state.permisosUsuario.forEach(e => {
          var regg = almacenFilter.filter(data => data.id == e.idAlmacen);
          if (regg.length > 0) {
            var item = {
              direccion: regg[0].direccion,
              id: regg[0].id,
              idTipoAlmacen: regg[0].idTipoAlmacen,
              nombre: regg[0].nombre
            }
            newArray.push(item);
          }

        });
        almacenFilter = newArray;
        formValues.idEstablecimiento = esta.length == 0 ? null : formValues.idEstablecimiento;
        formValues.idAlmacen = esta.length == 0 ? null : formValues.idAlmacen;
        formValues.idListaPrecio = esta.length == 0 ? null : formValues.idListaPrecio;
      }

      formValues.almacenes = almacenFilter ? almacenFilter : [];
      formValues.listasPrecio = this.state.listasPrecio.filter(
        (m) => m.idEstablecimiento === formValues.idEstablecimiento
      );
    }

    if (formValues.serie == "" || formValues.serie == null) {
      setTimeout(() => {
        dialog.error("Tiene que registrar serie correlativo para poder emitir el documento");

      }, 100);

    } else {

      this.setState({
        loadingNew: false,
        visible: true,
        formValues,
        unidadesMedida: formValues.unidadesMedida

        // productos: productos ? productos : []
      });
    }


  };


  handleEstablecimiento = () => {
    var newEstablecimiento = new Array();

    if (this.state.permisosUsuario.length == 0) {
      return newEstablecimiento;
    } else {
      //return establecimiento group by
      const Oreturn = this.handleGroupBy(this.state.permisosUsuario);

      Oreturn.forEach(element => {
        var obj = this.state.establecimientos.filter(m => m.id == element);
        if (obj.length > 0) {
          var item = {
            codigoSunat: obj[0].codigoSunat,
            direccion: obj[0].direccion,
            id: obj[0].id,
            idDepartamento: obj[0].idDepartamento,
            idProvincia: obj[0].idProvincia,
            idTipoEstablecimiento: obj[0].idTipoEstablecimiento,
            idUbigeo: obj[0].idUbigeo,
            nombre: obj[0].nombre,
            nombreTipoEstablecimiento: obj[0].nombreTipoEstablecimiento
          }
          newEstablecimiento.push(item);

        }
      });

    }
    return newEstablecimiento;
  }

  handleGroupBy(array) {
    var lista = new Array();
    array.forEach(element => {
      lista.push(element.idEstablecimiento);
    });

    return lista.filter((item, index) => lista.indexOf(item) === index);
  }

  handleEdit = async (item) => {

    var flagCrear = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_COMPRO).length >= 1 ? true : false;
    var flagPrecioEditar = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_PRECIO_VENTA).length >= 1 ? false : true;
    var flagCobranzaDirecta = this.state.configuraciones.filter((m) => m.abreviatura === PUNTO_VENTA_COBRANZA).length >= 1 ? true : false;

    if (!flagCrear) {
      message.warning('Usted no puede editar comprobantes.');
      return;
    }
    this.setState({ loadingEdit: true });
    const response = await comprobanteService.obtenerPorId(item.id);
    if (response === undefined) {
      this.setState({ loadingEdit: false });
      dialog.error("Ocurrió un error mientras se obtenia los datos.");
      return;
    }
    var params = auth.user().parametros;

    var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;
    var flagPrecioIncluyeIGV =
      params.filter(
        (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
      )[0].valor === "1"
        ? true
        : false;
    var MedidaAnticipo = response.flagAnticipo ? response.detalles[0].nombreUnidadMedida : "";
    var importarGuia = params.filter((m) => m.abreviatura === IMPORTAR_GRE)[0].valor === "1" ? true : false;

    var formValues = {
      id: response.id,
      idMovimiento: response.idMovimiento,
      idTipoComprobante: response.idTipoComprobante,
      idCliente: response.idCliente,
      idEstablecimientoCliente: response.idEstablecimientoCliente,
      direccionCliente: response.direccionCliente,
      idVendedor: response.idVendedor,
      idAlmacen: response.idAlmacen,
      idMoneda: response.idMoneda,
      flagGuiaImportar: importarGuia,
      //idCaja: response.idCaja,
      idCultivo: response.idCultivo,
      idFenologica: response.idFenologica,
      flagTipoBusquedaScanner: 0,
      idListaPrecio: response.idListaPrecio,
      idEstablecimiento: response.idEstablecimiento,
      idDetraccion: response.idDetraccion,
      idUsuarioRegistro: auth.user().id,
      serie: response.serie,
      documento: response.documento,
      idFormaPago: CONTADO,
      flagDocumentoEnviado: item.flagDocumentoEnviado,
      otroImpuesto: response.tipoImpuesto,
      idProyecto: response.idProyecto,
      idPendiente: auth.user().planCode == "PLA003" ? 1 : response.idPendiente,
      flagGuiaRemisionGeneraSalidas: response.paramGuiaRemisionGeneraSalidas,
      fechaStr: response.fechaStr,
      fechaVencimientoStr: response.fechaVencimientoStr,
      diasVencimiento: response.diasVencimiento,
      numeroPlaca: response.numeroPlaca,
      tipoCambio: response.tipoCambio,
      observacion: response.observacion,
      condicionPago: response.condicionPago,
      giroNegocio: response.giroNegocio,
      montoVuelto: response.montoVuelto,
      montoRecibido: response.montoRecibido,
      flagExportacion: response.flagExportacion,
      flagPercepcion: response.flagPercepcion,
      flagDetraccion: response.flagDetraccion,
      flagGrifo: response.flagGrifo,
      flagImpresion: response.flagImpresion,
      flagDescuentoGlobal: response.flagDescuentoGlobal,
      flagContingencia: response.flagContingencia,
      flagDisableSerieDocumento: response.flagContingencia ? false : true,
      flagDisableFecha:
        auth.user().parametros.filter((m) => m.abreviatura === VALIDAR_STOCK)[0]
          .valor === "1"
          ? true
          : false,
      listaComprobanteDetalle: [],
      listaComprobanteReferencia: [],
      listaComprobanteMetodoPago: [],

      idVehiculo: response.idVehiculo,
      encargado: response.encargado,

      flagAnticipo: response.flagAnticipo,
      flagRegularizacion: response.flagRegularizacion,
      totalAnticipo: response.totalAnticipo == undefined ? 0 : response.totalAnticipo,

      idMedidaAnticipo: MedidaAnticipo == "" ? 2 : MedidaAnticipo.includes("(BIENES)") ? 1 : 2,

      flagAmazoniaBien: response.flagAmazoniaBien,
      flagAmazoniaServicio: response.flagAmazoniaServicio,
      flagAmazonia: response.flagAmazonia,
      flagClaim: this.state.company.idTipoEmpresa == 2 ? true : false,

      nroOrden: response.nroOrden,
      /*********************/
      activeKey: "1",
      sumaTotalDetalle: response.totalDetalle,
      sumaImporteDescuento: response.importeDescuento,
      sumaSubTotal: response.subTotal,
      sumaIgv: response.igv,
      sumaIsc: response.isc,
      sumaTotal: response.total,
      importeDescuentoGlobal: response.importeDescuentoGlobal,
      porcentajeDescuentoGlobal: response.porcentajeDescuentoGlobal,
      porcentajeDetraccion: response.porcentajeDetraccion,
      importeDetraccion: response.importeDetraccion,
      totalDetraccion: response.totalDetraccion,
      porcentajePercepcion: response.porcentajePercepcion,
      importePercepcion: response.importePercepcion,
      totalPercepcion: response.totalPercepcion,
      totalDetailDisabled:
        auth
          .user()
          .parametros.filter(
            (m) => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO
          )[0].valor === "1"
          ? false
          : true,
      flagEmpresaGrifo: this.state.company.idTipoEmpresa == 1 ? true : false,

      flagImpuesto: auth.user().parametros.filter(m => m.abreviatura === VENTA_BLOQUEAR_IMPUESTOS)[0].valor === "1" ? true : false,
      flagEmpresaTaller: this.state.company?.idTipoEmpresa === 5,
      flagGiroNegocio: this.state.company.idTipoEmpresa == 4 ? true : false,

      precioUnitarioDetailDisabled: flagPrecioEditar,

      almacenLoading: false,
      clienteLoading: false,
      detalleProductos: [],
      sumaExonerada: response.totalDetalleExonerado,
      sumaInafecta: response.totalDetalleInafecto,
      sumaGratuita: response.totalDetalleGratuito,
    };
    // conversion de medida por lista de precio
    formValues.idTipoPrecio = this.state.listasPrecio.filter((m) => m.id == formValues.idListaPrecio);

    response.detalles.forEach(element => {
      const identifier = global.fetchUniqueCode();
      var itemsConversion = [];
      if (conversionMedida) {
        itemsConversion = element.itemConversion == null ? [] : JSON.parse(element.itemConversion);
      }

      formValues.listaComprobanteDetalle.push({
        identifier: identifier,
        idProducto: element.idProducto,
        idTipoProducto: element.idTipoProducto,
        codigo: element.codigoReferencia,
        nombre: element.nombre,
        numeroLote: element.numeroLote,
        nombreUnidadMedida: element.nombreUnidadMedida,
        idUnidadMedida: element.idUnidadMedida,
        flagAfecto: element.flagAfecto,
        flagAplicarSerie: element.flagAplicarSerie,
        flagExonerado: element.flagExonerado,
        flagGratuito: element.flagGratuito,
        flagISC: element.flagISC,
        isc: element.importeISC,
        porcentajeMargenComercial: element.porcentajeMargenComercial,
        precioPromedio: element.precioPromedio,
        precioUnitario: flagPrecioIncluyeIGV ? element.precioUnitario : element.precioUnitarioSinIGV,
        precioUnitarioSinIGV: element.precioUnitarioSinIGV,
        cantidad: element.cantidad,
        totalDetalle: element.totalDetalle,
        porcentajeDescuento: element.porcentajeDescuento,
        importeDescuento: element.importeDescuento,
        subTotal: element.subTotal,
        igv: element.igv,
        total: element.total,
        isItemLibre: element.isItemLibre,
        importado: true,
        idImpuesto: element.idImpuesto,
        flagConversion: element.flagConversion,
        itemConversion: itemsConversion ? itemsConversion : [],
        flagVencimiento: element.flagVencimiento,
        fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
        listaDetalleSerie: element.listaDetalleSerie,
        detalleSeries: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(u => u.serie).join(', ') : [],
        selectedSerie: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(m => m.serie) : [],
      });

      formValues.detalleProductos.push({
        identifier: identifier,
        idProducto: element.idProducto,
        idTipoProducto: element.idTipoProducto,
        nombre: element.nombre,
        numeroLote: element.numeroLote,
        idUnidadMedida: element.idUnidadMedida,
        cantidad: element.cantidad,
        porcentajeMargenComercial: element.porcentajeMargenComercial,
        precioPromedio: element.precioPromedio,
        precioUnitarioSinIGV: element.precioUnitarioSinIGV,
        precioUnitario: flagPrecioIncluyeIGV ? element.precioUnitario : element.precioUnitarioSinIGV,
        porcentajeDescuento: element.porcentajeDescuento,
        importeDescuento: element.importeDescuento,
        total: element.total,
        flagAfecto: element.flagAfecto,
        flagExonerado: element.flagExonerado,
        flagISC: element.flagISC,
        flagOtrosImpuesto: element.flagOtrosImpuesto,
        flagGratuito: element.flagGratuito,
        flagChangeTotal: element.flagChangeTotal,
        flagAplicarSerie: element.flagAplicarSerie,
        subTotal: element.subTotal,
        isItemLibre: element.isItemLibre,
        flagConversion: element.flagConversion,
        importado: true,
        idImpuesto: element.idImpuesto,
        itemConversion: itemsConversion ? itemsConversion : [],
        flagVencimiento: element.flagVencimiento,
        fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
        listaDetalleSerie: element.listaDetalleSerie,
        detalleSeries: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(u => u.serie).join(', ') : [],
        selectedSerie: element.listaDetalleSerie != null ? element.listaDetalleSerie.map(m => m.serie) : [],
      });
    });

    response.referencias.forEach((element) => {
      formValues.listaComprobanteReferencia.push({
        identifier: global.fetchUniqueCode(),
        flagInterno: element.flagInterno,
        idReferenciaOrigen: element.idReferenciaOrigen,
        idReferencia: element.idReferencia,
        idTipoComprobante: element.idTipoComprobante,
        serie: element.serie,
        documento: element.documento,
        importado: true,
      });
    });

    response.metodosPagos.forEach(element => {
      formValues.listaComprobanteMetodoPago.push({
        id: element.id,
        identifier: global.fetchUniqueCode(),
        fechaPago: element.fechaPagoStr,
        idCuenta: element.idCuenta,
        idMetodoPago: element.idMetodoPago,
        montoPago: element.montoPago,
        estado: element.estado
      });
    });

    formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;


    const clientes = await clienteService.getByComprobante({
      id: formValues.idCliente,
      value: '',
      type: [OTROS.CODIGO, DNI.CODIGO, CARNET_EXTRANJERIA.CODIGO, RUC.CODIGO, PASAPORTE.CODIGO].join(',')
    });
    const clienteFiltered = clientes.filter((m) => m.id === formValues.idCliente);
    var almacenes = await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
    if (almacenes != undefined && this.state.permisosUsuario.length > 0) {
      var esta = formValues.establecimientos.filter(data => data.id == formValues.idEstablecimiento);

      var newArray = new Array();
      var valido = false;
      this.state.permisosUsuario.forEach(e => {
        var regg = almacenes.filter(data => data.id == e.idAlmacen);
        if (regg.length > 0) {
          var item = {
            direccion: regg[0].direccion,
            id: regg[0].id,
            idTipoAlmacen: regg[0].idTipoAlmacen,
            nombre: regg[0].nombre
          }
          newArray.push(item);
          if (formValues.idAlmacen == regg[0].id) {
            valido = true
          }
        }
      });
      almacenes = newArray;

      formValues.idAlmacen = valido ? response.idAlmacen : null;

      formValues.idEstablecimiento = esta.length == 0 ? null : formValues.idEstablecimiento;
      formValues.idListaPrecio = esta.length == 0 ? null : formValues.idListaPrecio;
    }

    const idEntidad = clienteFiltered.length > 0 ? clienteFiltered[0].idEntidad : 0;
    const direcciones = await establecimientoService.listarPorIdEntidad(idEntidad);
    const vehiculos = await vehiculoService.obtenerPorClienteId(formValues.idCliente);

    const fenologicas = response.idCultivo == 0 ? [] : await fenologicaService.obtenerPorCultivoId(response.idCultivo);

    formValues.cultivos = this.state.cultivos;
    formValues.fenologicas = fenologicas;
    formValues.monedas = this.state.monedas;
    formValues.listasPrecio = this.state.listasPrecio.filter(
      (m) => m.idEstablecimiento === formValues.idEstablecimiento
    );
    formValues.metodosPagos = this.state.metodosPagos;
    formValues.cuentas = this.state.cuentas.filter(e => e.idMoneda == response.idMoneda);

    formValues.vendedores = this.state.vendedores;
    formValues.tiposComprobante = this.state.tiposComprobante.length === 0 ? await tipoComprobanteService.listar() : this.state.tiposComprobante;
    formValues.detracciones = this.state.detracciones.length === 0 ? await detraccionService.listar() : this.state.detracciones;
    formValues.clientes = clientes;
    formValues.documentoCliente =
      clienteFiltered.length > 0 ? clienteFiltered[0].numeroDocumento : "";
    formValues.almacenes = almacenes ? almacenes : [];
    formValues.direcciones = direcciones ? direcciones : [];
    formValues.pendientePago = this.state.pendientePago;
    formValues.caja = this.state.caja;
    formValues.unidadesMedida = this.state.unidadesMedida.length === 0 ? await unidadMedidaService.listar() : this.state.unidadesMedida;
    formValues.vehiculos = vehiculos ? vehiculos : [];
    formValues.Tipoimpuesto = lst_tipo_impuesto;
    formValues.proyectos = this.state.proyectos;
    formValues.flagCobranzaDirecta = auth.user().planCode == "PLA003" ? flagCobranzaDirecta : false;
    formValues.tipoAfectacion = lst_tipo_afectacion;

    this.setState({ loadingEdit: false, visible: true, formValues });
  };


  handleCopy = async (item) => {

    var flagCrear = this.state.configuraciones.filter((m) => m.abreviatura === CREAR_COPIAR_COMPRO).length >= 1 ? true : false;
    var flagPrecioEditar = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_PRECIO_VENTA).length >= 1 ? false : true;
    var flagCobranzaDirecta = this.state.configuraciones.filter((m) => m.abreviatura === PUNTO_VENTA_COBRANZA).length >= 1 ? true : false;
    var params = auth.user().parametros;

    if (!flagCrear) {
      message.warning('Usted no puede crear comprobantes.');
      return;
    }

    var controlDcumento = params.filter((m) => m.abreviatura === CONTROL_COMPBANTE)[0].valor === "1" ? true : false;
    if (controlDcumento) {
      if (this.state.totaldocument[0].total > auth.user().totalDocumentos) {
        message.error('Usted no puede crear comprobantes. ya supero la cantidad contratada');
        return;
      }
    }


    this.setState({ loadingCopy: true });
    const response = await comprobanteService.obtenerPorId(item.id);

    if (response === undefined) {
      this.setState({ loadingCopy: false });
      dialog.error("Ocurrió un error mientras se obtenia los datos.");
      return;
    }
    var paramGuiaRemisionGeneraSalidas =
      params.filter(
        (m) => m.abreviatura === VENTA_GUIA_REMISION_GENERA_SALIDAS
      )[0].valor === "1"
        ? true
        : false;

    var flagPrecioIncluyeIGV =
      params.filter(
        (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
      )[0].valor === "1"
        ? true
        : false;
    var MedidaAnticipo = response.flagAnticipo ? response.detalles[0].nombreUnidadMedida : "";
    var importarGuia = params.filter((m) => m.abreviatura === IMPORTAR_GRE)[0].valor === "1" ? true : false;

    var formValues = {
      id: 0,
      idMovimiento: 0,
      idTipoComprobante: response.idTipoComprobante,
      idCliente: response.idCliente,
      idEstablecimientoCliente: response.idEstablecimientoCliente,
      direccionCliente: response.direccionCliente,
      idVendedor: response.idVendedor,
      idAlmacen: response.idAlmacen,
      idMoneda: response.idMoneda,
      flagGuiaImportar: importarGuia,

      idCultivo: response.idCultivo,
      idFenologica: response.idFenologica,
      //idCaja: response.idCaja,
      idListaPrecio: response.idListaPrecio,
      idEstablecimiento: response.idEstablecimiento,
      idDetraccion: response.idDetraccion,
      idUsuarioRegistro: auth.user().id,
      serie: response.serie,
      documento: null,
      idFormaPago: CONTADO,
      idPendiente: 1,
      flagGuiaRemisionGeneraSalidas: response.paramGuiaRemisionGeneraSalidas,
      fechaStr: global.fetchCurrentDateStr(),
      fechaVencimientoStr: global.fetchCurrentDateStr(),
      diasVencimiento: 0,
      otroImpuesto: response.tipoImpuesto,
      numeroPlaca: response.numeroPlaca,
      tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS),
      observacion: response.observacion,
      flagExportacion: response.flagExportacion,
      flagPercepcion: response.flagPercepcion,
      flagDetraccion: response.flagDetraccion,
      flagGrifo: response.flagGrifo,
      flagDescuentoGlobal: response.flagDescuentoGlobal,
      flagContingencia: response.flagContingencia,
      flagDisableSerieDocumento: response.flagContingencia ? false : true,
      flagDisableFecha:
        auth.user().parametros.filter((m) => m.abreviatura === VALIDAR_STOCK)[0]
          .valor === "1"
          ? true
          : false,
      listaComprobanteDetalle: [],
      listaComprobanteReferencia: [],
      listaComprobanteMetodoPago: [],
      idVehiculo: response.idVehiculo,
      encargado: response.encargado,
      flagAnticipo: response.flagAnticipo,
      flagRegularizacion: response.flagRegularizacion,
      flagImpresion: response.flagImpresion,

      totalAnticipo: response.totalAnticipo == undefined ? 0 : response.totalAnticipo,
      idMedidaAnticipo: MedidaAnticipo == "" ? 2 : MedidaAnticipo.includes("(BIENES)") ? 1 : 2,
      idProyecto: 0,

      flagAmazoniaBien: response.flagAmazoniaBien,
      flagAmazoniaServicio: response.flagAmazoniaServicio,
      flagAmazonia: response.flagAmazonia,
      flagClaim: this.state.company.idTipoEmpresa == 2 ? true : false,

      nroOrden: response.nroOrden,

      /*********************/
      activeKey: "1",
      sumaTotalDetalle: response.totalDetalle,
      sumaImporteDescuento: response.importeDescuento,
      sumaSubTotal: response.subTotal,
      sumaIgv: response.igv,
      sumaIsc: response.isc,
      sumaTotal: response.total,
      importeDescuentoGlobal: response.importeDescuentoGlobal,
      porcentajeDescuentoGlobal: response.porcentajeDescuentoGlobal,
      porcentajeDetraccion: response.porcentajeDetraccion,
      importeDetraccion: response.importeDetraccion,
      totalDetraccion: response.totalDetraccion,
      porcentajePercepcion: response.porcentajePercepcion,
      importePercepcion: response.importePercepcion,
      totalPercepcion: response.totalPercepcion,
      totalDetailDisabled:
        auth
          .user()
          .parametros.filter(
            (m) => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO
          )[0].valor === "1"
          ? false
          : true,
      flagEmpresaGrifo: this.state.company.idTipoEmpresa == 1 ? true : false,
      flagImpuesto: auth.user().parametros.filter(m => m.abreviatura === VENTA_BLOQUEAR_IMPUESTOS)[0].valor === "1" ? true : false,
      precioUnitarioDetailDisabled: flagPrecioEditar,
      flagEmpresaTaller: this.state.company?.idTipoEmpresa === 5,

      almacenLoading: false,
      clienteLoading: false,
      detalleProductos: [],

      sumaExonerada: response.totalDetalleExonerado,
      sumaInafecta: response.totalDetalleInafecto,
      sumaGratuita: response.totalDetalleGratuito,
    };

    response.detalles.forEach((element) => {
      const identifier = global.fetchUniqueCode();
      formValues.listaComprobanteDetalle.push({
        identifier: identifier,
        idProducto: element.idProducto,
        idTipoProducto: element.idTipoProducto,
        codigo: element.codigoReferencia,
        nombre: element.nombre,
        numeroLote: element.numeroLote,
        nombreUnidadMedida: element.nombreUnidadMedida,
        idUnidadMedida: element.idUnidadMedida,
        flagAfecto: element.flagAfecto,
        flagExonerado: element.flagExonerado,
        flagGratuito: element.flagGratuito,
        flagISC: element.flagISC,
        isc: element.importeISC,
        porcentajeMargenComercial: element.porcentajeMargenComercial,
        precioPromedio: element.precioPromedio,
        precioUnitario: flagPrecioIncluyeIGV ? element.precioUnitario : element.precioUnitarioSinIGV,
        precioUnitarioSinIGV: element.precioUnitarioSinIGV,
        cantidad: element.cantidad,
        totalDetalle: element.totalDetalle,
        porcentajeDescuento: element.porcentajeDescuento,
        importeDescuento: element.importeDescuento,
        subTotal: element.subTotal,
        igv: element.igv,
        total: element.total,
        isItemLibre: element.isItemLibre,
        importado: true,
        idImpuesto: element.idImpuesto,
        flagConversion: element.flagConversion,
        itemConversion: [],
        flagVencimiento: element.flagVencimiento,
        fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null

      });

      formValues.detalleProductos.push({
        identifier: identifier,
        idProducto: element.idProducto,
        idTipoProducto: element.idTipoProducto,
        nombre: element.nombre,
        idUnidadMedida: element.idUnidadMedida,
        numeroLote: element.numeroLote,
        cantidad: element.cantidad,
        porcentajeMargenComercial: element.porcentajeMargenComercial,
        precioPromedio: element.precioPromedio,
        precioUnitarioSinIGV: element.precioUnitarioSinIGV,
        precioUnitario: flagPrecioIncluyeIGV ? element.precioUnitario : element.precioUnitarioSinIGV,
        porcentajeDescuento: element.porcentajeDescuento,
        importeDescuento: element.importeDescuento,
        total: element.total,
        flagAfecto: element.flagAfecto,
        flagExonerado: element.flagExonerado,
        flagISC: element.flagISC,
        flagOtrosImpuesto: element.flagOtrosImpuesto,
        flagGratuito: element.flagGratuito,
        flagChangeTotal: element.flagChangeTotal,
        subTotal: element.subTotal,
        isItemLibre: element.isItemLibre,
        importado: true,
        idImpuesto: element.idImpuesto,
        flagConversion: element.flagConversion,
        itemConversion: [],
        flagVencimiento: element.flagVencimiento,
        fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null

      });
    });


    /* 
        response.metodosPagos.forEach(element => {
          formValues.listaComprobanteMetodoPago.push({
            identifier: global.fetchUniqueCode(),
            fechaPago: element.fechaPagoStr,
            idCuenta: element.idCuenta,
            idMetodoPago: element.idMetodoPago,
            montoPago: element.montoPago,
            estado: element.estado
          });
        });
     */
    // conversion de medida por lista de precio
    formValues.idTipoPrecio = this.state.listasPrecio.filter((m) => m.id == formValues.idListaPrecio);
    //const clientes = await clienteService.listar();
    const clientes = await clienteService.getByComprobante({
      id: formValues.idCliente,
      value: '',
      type: [OTROS.CODIGO, DNI.CODIGO, CARNET_EXTRANJERIA.CODIGO, RUC.CODIGO, PASAPORTE.CODIGO].join(',')
    });
    const clienteFiltered = clientes.filter((m) => m.id === formValues.idCliente);
    var almacenes = await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
    formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;
    const fenologicas = response.idCultivo == 0 ? [] : await fenologicaService.obtenerPorCultivoId(response.idCultivo);

    if (almacenes != undefined && this.state.permisosUsuario.length > 0) {
      var newArray = new Array();
      var valido = false;
      var esta = formValues.establecimientos.filter(data => data.id == formValues.idEstablecimiento);

      this.state.permisosUsuario.forEach(e => {
        var regg = almacenes.filter(data => data.id == e.idAlmacen);
        if (regg.length > 0) {
          var item = {
            direccion: regg[0].direccion,
            id: regg[0].id,
            idTipoAlmacen: regg[0].idTipoAlmacen,
            nombre: regg[0].nombre
          }
          newArray.push(item);
          if (formValues.idAlmacen == regg[0].id) {
            valido = true
          }
        }

      });
      almacenes = newArray;
      formValues.idAlmacen = valido ? response.idAlmacen : null;
      formValues.idEstablecimiento = esta.length == 0 ? null : formValues.idEstablecimiento;
      formValues.idListaPrecio = esta.length == 0 ? null : formValues.idListaPrecio;

    }

    const idEntidad =
      clienteFiltered.length > 0 ? clienteFiltered[0].idEntidad : 0;
    const direcciones = await establecimientoService.listarPorIdEntidad(idEntidad);
    const vehiculos = await vehiculoService.obtenerPorClienteId(formValues.idCliente);


    formValues.cultivos = this.state.cultivos;
    formValues.fenologicas = fenologicas;
    formValues.monedas = this.state.monedas;
    formValues.listasPrecio = this.state.listasPrecio.filter(
      (m) => m.idEstablecimiento === formValues.idEstablecimiento
    );
    formValues.metodosPagos = this.state.metodosPagos;
    formValues.cuentas = this.state.cuentas.filter(e => e.idMoneda == response.idMoneda);

    formValues.vendedores = this.state.vendedores;
    formValues.tiposComprobante = this.state.tiposComprobante.length === 0 ? await tipoComprobanteService.listar() : this.state.tiposComprobante;
    formValues.detracciones = this.state.detracciones.length === 0 ? await detraccionService.listar() : this.state.detracciones;
    formValues.clientes = clientes;
    formValues.documentoCliente =
      clienteFiltered.length > 0 ? clienteFiltered[0].numeroDocumento : "";
    formValues.almacenes = almacenes ? almacenes : [];
    formValues.direcciones = direcciones ? direcciones : [];
    formValues.pendientePago = this.state.pendientePago;
    formValues.caja = this.state.caja;
    formValues.unidadesMedida = this.state.unidadesMedida.length === 0 ? await unidadMedidaService.listar() : this.state.unidadesMedida;
    formValues.vehiculos = vehiculos ? vehiculos : [];
    formValues.proyectos = this.state.proyectos;
    formValues.Tipoimpuesto = lst_tipo_impuesto;
    formValues.flagCobranzaDirecta = auth.user().planCode == "PLA003" ? flagCobranzaDirecta : false;
    formValues.tipoAfectacion = lst_tipo_afectacion;


    this.setState({ loadingCopy: false, visible: true, formValues });
  };



  handleSave = async (item, form) => {

    this.setState({ saveLoading: true });
    var montoMaximoVenta = auth
      .user()
      .parametros.filter(
        (m) => m.abreviatura === VENTA_VALIDAR_TOPE_MAXIMO_VENTAS_SOLES
      )[0].valor;
    if (item.total >= parseFloat(montoMaximoVenta)) {
      dialog.confirm(
        "El total de la venta excede el monto máximo establecido " +
        global.decimalFormat(parseFloat(montoMaximoVenta).toFixed(2)) +
        " ¿Desea continuar?",
        async () => {
          this.handleSaveUpdate(item, form);
        },
        async () => {
          this.setState({ saveLoading: false });
        }
      );
    } else {
      this.handleSaveUpdate(item, form);
    }
  };

  handleSaveUpdate = async (item, form) => {
    var envioAutomatico = this.state.configuraciones.filter((m) => m.abreviatura === EMISION_AUTO).length >= 1 ? true : false;

    dialog.confirm(
      "¿Esta seguro de realizar la acción?",
      async () => {
        var response;
        if (item.id === 0) response = await comprobanteService.registrar(item);
        else response = await comprobanteService.modificar(item);

        if (response.status === 200) {
          form.resetFields();
          message.success(
            (item.id === 0 ? "Registrado" : "Modificado") + " correctamente."
          );
          this.setState({ visible: false, saveLoading: false });
          this._handlePagination(this.state.filter);

          if (envioAutomatico) {
            setTimeout(() => {
              this.setState({ loadingEmitir: true, loadingEdit: true });
              this.handleEnvioComprobantes(item.id === 0 ? response.data : item.id);
            }, 1000);
          }

          return;
        }

        if (response.status === 400) {
          dialog.warning(
            <ul>
              {response.data.messages.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
          );
          this.setState({ saveLoading: false });
          return;
        }

        dialog.error(
          "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
        );
        this.setState({ saveLoading: false });
      },
      async () => {
        this.setState({ saveLoading: false });
      }
    );
  };

  handleEnvioComprobantes = async (data) => {

    var response = await comprobanteService.emitir({ id: data });
    if (response.status === 400) {
      dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
    }
    this._handlePagination(this.state.filter);
    this.setState({ loadingEmitir: false, loadingEdit: false });

  }


  handleImportarPedido = async (onSetFieldsValue, onGetFieldValue) => {
    this.setState(
      {
        onSetFieldsValue,
        onGetFieldValue,
      },
      async () => {
        var idCliente = this.state.onGetFieldValue("idCliente");

        var filter = {
          idCliente: idCliente === undefined ? 0 : idCliente.key,
          serie: "",
          documento: "",
        };

        if (idCliente === undefined) {
          dialog.error("Debe seleccionar un Cliente");
          return;
        } else {

          var response = await pedidoService.importarRegistrados(filter);

          this.setState({
            importarVisible: true,
            importarFormValues: {
              ...this.state.importarFormValues,
              dataSource: response,
            },
          });


        }


      }
    );
  };

  handleSelectPedido = async (selected, row, form) => {

    var response = undefined;
    var productos = this.state.onGetFieldValue("detalleProductos");

    var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
    var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

    var sumaTotalDetalle = 0;
    var sumaImporteDescuento = 0;
    var sumaSubTotal = 0;
    var sumaIgv = 0;
    var sumaIsc = 0;
    var sumaTotal = 0;
    var obj = {};
    var totalMetodoPago = 0;


    if (row.length == 0) {

      listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
      listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
      productos = productos.filter(e => e.importado == true);

      if (listaComprobanteReferencia.length > 0)
        totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));


      setTimeout(() => {
        this.setState({
          formValues: {
            ...this.state.formValues,
            listaComprobanteDetalle,
            listaComprobanteReferencia
          },
          importarFormValues: {
            ...this.state.importarFormValues,
            selectedRowKeys: selected
          }
        })

        this.state.onSetFieldsValue({

          detalleProductos: productos,
          sumaTotalDetalle: sumaTotalDetalle + (totalMetodoPago / 1.18),
          sumaImporteDescuento: sumaImporteDescuento,
          sumaSubTotal: sumaSubTotal + (totalMetodoPago / 1.18),
          sumaIgv: sumaIgv + (totalMetodoPago - (totalMetodoPago / 1.18)),
          sumaIsc: sumaIsc,
          sumaTotal: sumaTotal + totalMetodoPago
        });
      }, 100)
    }
    if (row.length == 1) {

      listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
      listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
      productos = productos.filter(e => e.importado == true);

      if (listaComprobanteReferencia.length > 0)
        totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

      response = await pedidoService.obtenerPorId(row[0].id);

      response.pedidoDetalles.forEach(element => {
        const identifier = global.fetchUniqueCode();

        var itemsConversion = [];

        listaComprobanteDetalle.push({
          identifier: identifier,
          idProducto: element.idProducto,
          idTipoProducto: element.idTipoProducto,
          codigo: element.codigoReferencia,
          nombre: element.nombre,
          numeroLote: element.numeroLote,
          nombreUnidadMedida: element.nombreUnidadMedida,
          idUnidadMedida: element.idUnidadMedida,
          flagAplicarSerie: element.flagAplicarSerie,
          flagAfecto: element.flagAfecto,
          flagExonerado: element.flagExonerado,
          flagGratuito: element.flagGratuito,
          flagISC: element.flagISC,
          isc: element.importeISC,
          porcentajeMargenComercial: element.porcentajeMargenComercial,
          precioPromedio: element.precioPromedio,
          precioUnitario: element.precioUnitario,
          precioUnitarioSinIGV: element.precioUnitarioSinIGV,
          cantidad: element.cantidad,
          totalDetalle: element.totalDetalle.toFixed(2),
          porcentajeDescuento: element.porcentajeDescuento,
          importeDescuento: element.importeDescuento,
          subTotal: element.subTotal,
          igv: element.igv,
          total: element.total,
          flagConversion: element.flagConversion,
          itemConversion: itemsConversion,
          flagVencimiento: element.flagVencimiento,
          fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
          idImpuesto: element.idImpuesto,
          listaDetalleSerie: []
        });

        productos.push({
          identifier: identifier,
          idProducto: element.idProducto,
          idTipoProducto: element.idTipoProducto,
          nombre: element.nombre,
          numeroLote: element.numeroLote,
          cantidad: element.cantidad,
          idUnidadMedida: element.idUnidadMedida,
          porcentajeMargenComercial: element.porcentajeMargenComercial,
          precioPromedio: element.precioPromedio,
          precioUnitarioSinIGV: element.precioUnitarioSinIGV,
          precioUnitario: element.precioUnitario,
          porcentajeDescuento: element.porcentajeDescuento,
          importeDescuento: element.importeDescuento,
          total: element.total,
          flagAplicarSerie: element.flagAplicarSerie,
          flagAfecto: element.flagAfecto,
          flagISC: element.flagISC,
          flagOtrosImpuesto: element.flagOtrosImpuesto,
          flagGratuito: element.flagGratuito,
          flagChangeTotal: element.flagChangeTotal,
          subTotal: element.subTotal,
          importado: false,
          flagConversion: element.flagConversion,
          itemConversion: itemsConversion,
          flagVencimiento: element.flagVencimiento,
          idImpuesto: element.idImpuesto,
          fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
          listaDetalleSerie: []
        });
      });

      listaComprobanteReferencia.push({
        identifier: global.fetchUniqueCode(),
        idReferencia: response.pedido.id,
        flagInterno: true,
        idReferenciaOrigen: VENTAS_PEDIDO,
        idTipoComprobante: response.pedido.idTipoComprobante,
        serie: response.pedido.serie,
        documento: response.pedido.documento,
        importado: false,
      });

      listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);

      totalMetodoPago = (totalMetodoPago - this.state.formValues.totalAnticipo);
      if (this.state.formValues.totalAnticipo > 0) {
        listaComprobanteReferencia = listaComprobanteReferencia.concat(this.state.importarAnticipo.listaComprobanteReferencia);
      }

      obj = {
        sumaTotalDetalle: response.pedido.totalDetalle + (totalMetodoPago / 1.18),
        sumaImporteDescuento: response.pedido.importeDescuento + sumaImporteDescuento,
        sumaSubTotal: response.pedido.subTotal + (totalMetodoPago / 1.18),
        sumaIgv: response.pedido.igv + (totalMetodoPago - (totalMetodoPago / 1.18)),
        sumaIsc: response.pedido.isc + sumaIsc,
        sumaTotal: response.pedido.total + totalMetodoPago,
      }


      this.SelectPedido(response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj);

    }

    var contador = 0;
    if (row.length > 1) {

      listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
      listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
      productos = productos.filter(e => e.importado == true);

      if (listaComprobanteReferencia.length > 0)
        totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

      row.forEach(async (item) => {

        response = await pedidoService.obtenerPorId(item.id);

        response.pedidoDetalles.forEach(element => {
          const identifier = global.fetchUniqueCode();
          var itemsConversion = [];

          listaComprobanteDetalle.push({
            identifier: identifier,
            idProducto: element.idProducto,
            idTipoProducto: element.idTipoProducto,
            codigo: element.codigoReferencia,
            nombre: element.nombre,
            numeroLote: element.numeroLote,
            nombreUnidadMedida: element.nombreUnidadMedida,
            idUnidadMedida: element.idUnidadMedida,
            flagAplicarSerie: element.flagAplicarSerie,
            flagAfecto: element.flagAfecto,
            flagGratuito: element.flagGratuito,
            flagISC: element.flagISC,
            isc: element.importeISC,
            porcentajeMargenComercial: element.porcentajeMargenComercial,
            precioPromedio: element.precioPromedio,
            precioUnitario: element.precioUnitario,
            precioUnitarioSinIGV: element.precioUnitarioSinIGV,
            cantidad: element.cantidad,
            totalDetalle: element.totalDetalle.toFixed(2),
            porcentajeDescuento: element.porcentajeDescuento,
            importeDescuento: element.importeDescuento,
            subTotal: element.subTotal,
            igv: element.igv,
            total: element.total,
            importado: false,
            flagConversion: element.flagConversion,
            itemConversion: itemsConversion,
            flagVencimiento: element.flagVencimiento,
            idImpuesto: element.idImpuesto,
            fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
            listaDetalleSerie: []
          });

          productos.push({
            identifier: identifier,
            idProducto: element.idProducto,
            idTipoProducto: element.idTipoProducto,
            nombre: element.nombre,
            numeroLote: element.numeroLote,
            cantidad: element.cantidad,
            idUnidadMedida: element.idUnidadMedida,
            porcentajeMargenComercial: element.porcentajeMargenComercial,
            precioPromedio: element.precioPromedio,
            precioUnitarioSinIGV: element.precioUnitarioSinIGV,
            precioUnitario: element.precioUnitario,
            porcentajeDescuento: element.porcentajeDescuento,
            importeDescuento: element.importeDescuento,
            total: element.total,
            flagAplicarSerie: element.flagAplicarSerie,
            flagAfecto: element.flagAfecto,
            flagISC: element.flagISC,
            flagOtrosImpuesto: element.flagOtrosImpuesto,
            flagGratuito: element.flagGratuito,
            flagChangeTotal: element.flagChangeTotal,
            subTotal: element.subTotal,
            importado: false,
            flagConversion: element.flagConversion,
            itemConversion: itemsConversion,
            flagVencimiento: element.flagVencimiento,
            idImpuesto: element.idImpuesto,
            fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
            listaDetalleSerie: []
          });
        });

        listaComprobanteReferencia.push({
          identifier: global.fetchUniqueCode(),
          idReferencia: response.pedido.id,
          flagInterno: true,
          idReferenciaOrigen: VENTAS_PEDIDO,
          idTipoComprobante: response.pedido.idTipoComprobante,
          serie: response.pedido.serie,
          documento: response.pedido.documento,
          importado: false,
        });

        sumaTotalDetalle = response.pedido.totalDetalle + sumaTotalDetalle;
        sumaImporteDescuento = response.pedido.importeDescuento + sumaImporteDescuento;
        sumaSubTotal = response.pedido.subTotal + sumaSubTotal;
        sumaIgv = response.pedido.igv + sumaIgv;
        sumaIsc = response.pedido.isc + sumaIsc;
        sumaTotal = response.pedido.total + sumaTotal;

        contador++;

        if (contador == row.length) {
          listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);

          totalMetodoPago = (totalMetodoPago - this.state.formValues.totalAnticipo);
          if (this.state.formValues.totalAnticipo > 0) {
            listaComprobanteReferencia = listaComprobanteReferencia.concat(this.state.importarAnticipo.listaComprobanteReferencia);
          }

          obj = {
            sumaTotalDetalle: sumaTotalDetalle + (totalMetodoPago / 1.18),
            sumaImporteDescuento: sumaImporteDescuento,
            sumaSubTotal: sumaSubTotal + (totalMetodoPago / 1.18),
            sumaIgv: sumaIgv + (totalMetodoPago - (totalMetodoPago / 1.18)),
            sumaIsc: sumaIsc,
            sumaTotal: sumaTotal + totalMetodoPago,
          }

          this.SelectPedido(response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj);

        }
      })

    }



  };

  SelectPedido = async (response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj) => {


    var listaMetodoPago = [];
    const almacenes = await almacenService.listarPorIdEstablecimiento(response.pedido.idEstablecimiento);
    const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === response.pedido.idEstablecimiento);
    var formValues = {
      ...this.state.formValues,
      almacenes: almacenes,
      listasPrecio: listasPrecio,
      idEstablecimiento: response.pedido.idEstablecimiento,
      idAlmacen: response.pedido.idAlmacen,
      idMoneda: response.pedido.idMoneda,
      idProyecto: response.pedido.idProyecto,
      idListaPrecio: response.pedido.idListaPrecio,
      listaComprobanteDetalle: listaComprobanteDetalle,
      listaComprobanteReferencia: listaComprobanteReferencia,
      listaComprobanteMetodoPago: listaMetodoPago,
      isImportando: true,
      encargado: response.pedido.encargado,
      idVehiculo: response.pedido.idVehiculo,
      observacion: response.pedido.observacion,
      otroImpuesto: response.pedido.tipoImpuesto,
      idVendedor: response.pedido.idVendedor,

    };

    if ((formValues.idCliente === 0 || formValues.idCliente === undefined) &&
      response.pedido.idCliente !== null && response.pedido.idCliente !== undefined &&
      formValues.clientes.filter(m => m.id === response.pedido.idCliente).length !== 0) {
      const direcciones = await establecimientoService.listarPorIdEntidad(response.pedido.idEntidadCliente);
      formValues.documentoCliente = response.pedido.numeroDocumentoCliente;
      formValues.idCliente = response.pedido.idCliente;
      formValues.direcciones = direcciones;
      formValues.idEstablecimientoCliente = direcciones[0].id;
    }


    this.setState({
      almacenes: formValues.almacenes,
      listasPrecio: formValues.listasPrecio,
      direcciones: formValues.direcciones,
      formValues: formValues,
      importarFormValues: {
        ...this.state.importarFormValues,
        selectedRowKeys: selected
      }
    }, () => {
      var detalleProductos = [];
      productos.forEach(producto => {
        detalleProductos.push(producto);
      });

      this.state.onSetFieldsValue({
        //idCliente: formValues.idCliente !== 0 ? { key: formValues.idCliente} : undefined,
        /*                idEstablecimientoCliente: formValues.idEstablecimientoCliente !== 0 ? { key: formValues.idEstablecimientoCliente} : undefined,
                       documentoCliente : formValues.documentoCliente,
                       idEstablecimiento: { key: response.cotizacion.idEstablecimiento }, */
        idAlmacen: { key: response.pedido.idAlmacen },
        idProyecto: { key: response.pedido.idProyecto },
        idListaPrecio: { key: response.pedido.idListaPrecio },
        idMoneda: { key: response.pedido.idMoneda },
        otroImpuesto: { key: response.pedido.tipoImpuesto },
        detalleProductos: detalleProductos,
        idTipoComprobanteImportado: response.pedido.idTipoComprobante,
        sumaTotalDetalle: obj.sumaTotalDetalle,
        sumaImporteDescuento: obj.sumaImporteDescuento,
        sumaSubTotal: obj.sumaSubTotal,
        sumaIgv: obj.sumaIgv,
        sumaIsc: obj.sumaIsc,
        sumaTotal: obj.sumaTotal,
      });
    });
  }


  handleImportarCotizacion = async (onSetFieldsValue, onGetFieldValue) => {
    this.setState(
      {
        onSetFieldsValue,
        onGetFieldValue,
      },
      async () => {
        var idCliente = this.state.onGetFieldValue("idCliente");
        var idMoneda = this.state.onGetFieldValue("idMoneda");

        var filter = {
          idCliente: idCliente === undefined ? 0 : idCliente.key,
          serie: "",
          documento: "",
          idMoneda: idMoneda === undefined ? 0 : idMoneda.key,

        };


        if (idCliente === undefined) {
          dialog.error("Debe seleccionar un Cliente");
          return;
        } else {

          var response = await cotizacionService.importarRegistrados(filter);
          debugger


          this.setState({
            importarCotizacionVisible: true,
            importarCotizacionFormValues: {
              ...this.state.importarCotizacionFormValues,
              dataSource: response,
              selectedRowKeys: this.state.formValues.listaComprobanteReferencia.map(function (v) {
                return v.serie + '-' + v.documento;
              })
            },
          });
        }



      }
    );
  };

  handleSelectCotizacion = async (selected, row, form) => {

    var response = undefined;
    var productos = this.state.onGetFieldValue("detalleProductos");

    var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
    var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

    var sumaTotalDetalle = 0;
    var sumaImporteDescuento = 0;
    var sumaSubTotal = 0;
    var sumaIgv = 0;
    var sumaIsc = 0;
    var sumaTotal = 0;
    var obj = {};
    var totalMetodoPago = 0;



    if (row.length == 0) {

      listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
      listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
      productos = productos.filter(e => e.importado == true);

      if (listaComprobanteReferencia.length > 0)
        totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));


      setTimeout(() => {
        this.setState({
          formValues: {
            ...this.state.formValues,
            listaComprobanteDetalle,
            listaComprobanteReferencia
          },
          importarCotizacionFormValues: {
            ...this.state.importarCotizacionFormValues,
            selectedRowKeys: selected
          }
        })

        this.state.onSetFieldsValue({

          detalleProductos: productos,
          sumaTotalDetalle: sumaTotalDetalle + (totalMetodoPago / 1.18),
          sumaImporteDescuento: sumaImporteDescuento,
          sumaSubTotal: sumaSubTotal + (totalMetodoPago / 1.18),
          sumaIgv: sumaIgv + (totalMetodoPago - (totalMetodoPago / 1.18)),
          sumaIsc: sumaIsc,
          sumaTotal: sumaTotal + totalMetodoPago
        });
      }, 100)
    }
    if (row.length == 1) {

      listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
      listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
      productos = productos.filter(e => e.importado == true);

      if (listaComprobanteReferencia.length > 0)
        totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

      response = await cotizacionService.obtenerPorId(row[0].id);

      response.cotizacionDetalles.forEach(element => {
        const identifier = global.fetchUniqueCode();
        var itemsConversion = [];

        listaComprobanteDetalle.push({
          identifier: identifier,
          idProducto: element.idProducto,
          idTipoProducto: element.idTipoProducto,
          codigo: element.codigoReferencia,
          nombre: element.nombre,
          numeroLote: element.numeroLote,
          nombreUnidadMedida: element.nombreUnidadMedida,
          idUnidadMedida: row.idUnidadMedida,
          flagAplicarSerie: element.flagAplicarSerie,
          flagAfecto: element.flagAfecto,
          flagGratuito: element.flagGratuito,
          flagISC: element.flagISC,
          isc: element.importeISC,
          porcentajeMargenComercial: element.porcentajeMargenComercial,
          precioPromedio: element.precioPromedio,
          precioUnitario: element.precioUnitario,
          precioUnitarioSinIGV: element.precioUnitarioSinIGV,
          cantidad: element.cantidad,
          totalDetalle: element.totalDetalle.toFixed(2),
          porcentajeDescuento: element.porcentajeDescuento,
          importeDescuento: element.importeDescuento,
          subTotal: element.subTotal,
          igv: element.igv,
          total: element.total,
          importado: false,
          flagConversion: element.flagConversion,
          itemConversion: itemsConversion,
          flagVencimiento: element.flagVencimiento,
          fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
          idImpuesto: element.idImpuesto,
          listaDetalleSerie: []

        });

        productos.push({
          identifier: identifier,
          idProducto: element.idProducto,
          idTipoProducto: element.idTipoProducto,
          nombre: element.nombre,
          numeroLote: element.numeroLote,
          cantidad: element.cantidad,
          idUnidadMedida: element.idUnidadMedida,
          porcentajeMargenComercial: element.porcentajeMargenComercial,
          precioPromedio: element.precioPromedio,
          precioUnitarioSinIGV: element.precioUnitarioSinIGV,
          precioUnitario: element.precioUnitario,
          porcentajeDescuento: element.porcentajeDescuento,
          importeDescuento: element.importeDescuento,
          total: element.total,
          flagAplicarSerie: element.flagAplicarSerie,
          flagAfecto: element.flagAfecto,
          flagISC: element.flagISC,
          flagOtrosImpuesto: element.flagOtrosImpuesto,
          flagGratuito: element.flagGratuito,
          flagChangeTotal: element.flagChangeTotal,
          subTotal: element.subTotal,
          importado: false,
          flagConversion: element.flagConversion,
          itemConversion: itemsConversion,
          flagVencimiento: element.flagVencimiento,
          fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
          idImpuesto: element.idImpuesto,
          listaDetalleSerie: []
        });



      });

      listaComprobanteReferencia.push({
        identifier: global.fetchUniqueCode(),
        idReferencia: response.cotizacion.id,
        flagInterno: true,
        idReferenciaOrigen: VENTAS_COTIZACION,
        idTipoComprobante: response.cotizacion.idTipoComprobante,
        serie: response.cotizacion.serie,
        documento: response.cotizacion.documento,
        importado: false,
      });

      listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);

      obj = {
        sumaTotalDetalle: response.cotizacion.totalDetalle + (totalMetodoPago / 1.18),
        sumaImporteDescuento: response.cotizacion.importeDescuento + sumaImporteDescuento,
        sumaSubTotal: response.cotizacion.subTotal + (totalMetodoPago / 1.18),
        sumaIgv: response.cotizacion.igv + (totalMetodoPago - (totalMetodoPago / 1.18)),
        sumaIsc: response.cotizacion.isc + sumaIsc,
        sumaTotal: response.cotizacion.total + totalMetodoPago,
      }


      this.SelectCotizacion(response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj);

    }

    var contador = 0;
    if (row.length > 1) {

      listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
      listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
      productos = productos.filter(e => e.importado == true);

      if (listaComprobanteReferencia.length > 0)
        totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

      row.forEach(async (item) => {

        response = await cotizacionService.obtenerPorId(item.id);

        response.cotizacionDetalles.forEach(element => {
          const identifier = global.fetchUniqueCode();
          var itemsConversion = [];

          listaComprobanteDetalle.push({
            identifier: identifier,
            idProducto: element.idProducto,
            idTipoProducto: element.idTipoProducto,
            codigo: element.codigoReferencia,
            nombre: element.nombre,
            numeroLote: element.numeroLote,
            nombreUnidadMedida: element.nombreUnidadMedida,
            idUnidadMedida: row.idUnidadMedida,
            flagAplicarSerie: element.flagAplicarSerie,
            flagAfecto: element.flagAfecto,
            flagGratuito: element.flagGratuito,
            flagISC: element.flagISC,
            isc: element.importeISC,
            porcentajeMargenComercial: element.porcentajeMargenComercial,
            precioPromedio: element.precioPromedio,
            precioUnitario: element.precioUnitario,
            precioUnitarioSinIGV: element.precioUnitarioSinIGV,
            cantidad: element.cantidad,
            totalDetalle: element.totalDetalle.toFixed(2),
            porcentajeDescuento: element.porcentajeDescuento,
            importeDescuento: element.importeDescuento,
            subTotal: element.subTotal,
            igv: element.igv,
            total: element.total,
            importado: false,
            flagConversion: element.flagConversion,
            itemConversion: itemsConversion,
            flagVencimiento: element.flagVencimiento,
            fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
            idImpuesto: element.idImpuesto,
            listaDetalleSerie: []
          });

          productos.push({
            identifier: identifier,
            idProducto: element.idProducto,
            idTipoProducto: element.idTipoProducto,
            nombre: element.nombre,
            numeroLote: element.numeroLote,
            cantidad: element.cantidad,
            idUnidadMedida: row.idUnidadMedida,
            porcentajeMargenComercial: element.porcentajeMargenComercial,
            precioPromedio: element.precioPromedio,
            precioUnitarioSinIGV: element.precioUnitarioSinIGV,
            precioUnitario: element.precioUnitario,
            porcentajeDescuento: element.porcentajeDescuento,
            importeDescuento: element.importeDescuento,
            total: element.total,
            flagAplicarSerie: element.flagAplicarSerie,
            flagAfecto: element.flagAfecto,
            flagISC: element.flagISC,
            flagOtrosImpuesto: element.flagOtrosImpuesto,
            flagGratuito: element.flagGratuito,
            flagChangeTotal: element.flagChangeTotal,
            subTotal: element.subTotal,
            importado: false,
            flagConversion: element.flagConversion,
            itemConversion: itemsConversion,
            flagVencimiento: element.flagVencimiento,
            fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null,
            idImpuesto: element.idImpuesto,
            listaDetalleSerie: []
          });
        });

        listaComprobanteReferencia.push({
          identifier: global.fetchUniqueCode(),
          idReferencia: response.cotizacion.id,
          flagInterno: true,
          idReferenciaOrigen: VENTAS_COTIZACION,
          idTipoComprobante: response.cotizacion.idTipoComprobante,
          serie: response.cotizacion.serie,
          documento: response.cotizacion.documento,
          importado: false,
        });

        sumaTotalDetalle = response.cotizacion.totalDetalle + sumaTotalDetalle;
        sumaImporteDescuento = response.cotizacion.importeDescuento + sumaImporteDescuento;
        sumaSubTotal = response.cotizacion.subTotal + sumaSubTotal;
        sumaIgv = response.cotizacion.igv + sumaIgv;
        sumaIsc = response.cotizacion.isc + sumaIsc;
        sumaTotal = response.cotizacion.total + sumaTotal;

        contador++;

        if (contador == row.length) {
          listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);

          obj = {
            sumaTotalDetalle: sumaTotalDetalle + (totalMetodoPago / 1.18),
            sumaImporteDescuento: sumaImporteDescuento,
            sumaSubTotal: sumaSubTotal + (totalMetodoPago / 1.18),
            sumaIgv: sumaIgv + (totalMetodoPago - (totalMetodoPago / 1.18)),
            sumaIsc: sumaIsc,
            sumaTotal: sumaTotal + totalMetodoPago,
          }

          this.SelectCotizacion(response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj);

        }
      })

    }



  };

  SelectCotizacion = async (response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj) => {


    var listaMetodoPago = [];
    const almacenes = await almacenService.listarPorIdEstablecimiento(response.cotizacion.idEstablecimiento);
    const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === response.cotizacion.idEstablecimiento);
    var formValues = {
      ...this.state.formValues,
      almacenes: almacenes,
      listasPrecio: listasPrecio,
      idEstablecimiento: response.cotizacion.idEstablecimiento,
      idAlmacen: response.cotizacion.idAlmacen,
      idMoneda: response.cotizacion.idMoneda,
      idListaPrecio: response.cotizacion.idListaPrecio,
      listaComprobanteDetalle: listaComprobanteDetalle,
      listaComprobanteReferencia: listaComprobanteReferencia,
      listaComprobanteMetodoPago: listaMetodoPago,
      isImportando: true,
      encargado: response.cotizacion.encargado,
      idVehiculo: response.cotizacion.idVehiculo,
      idProyecto: response.cotizacion.idProyecto,

      observacion: response.cotizacion.observacion,
      otroImpuesto: response.cotizacion.tipoImpuesto,
      idVendedor: response.cotizacion.idVendedor,

    };

    if ((formValues.idCliente === 0 || formValues.idCliente === undefined) &&
      response.cotizacion.idCliente !== null && response.cotizacion.idCliente !== undefined &&
      formValues.clientes.filter(m => m.id === response.cotizacion.idCliente).length !== 0) {
      const direcciones = await establecimientoService.listarPorIdEntidad(response.cotizacion.idEntidadCliente);
      formValues.documentoCliente = response.cotizacion.numeroDocumentoCliente;
      formValues.idCliente = response.cotizacion.idCliente;
      formValues.direcciones = direcciones;
      formValues.idEstablecimientoCliente = direcciones[0].id;
    }


    this.setState({
      almacenes: formValues.almacenes,
      listasPrecio: formValues.listasPrecio,
      direcciones: formValues.direcciones,
      formValues: formValues,
      importarCotizacionFormValues: {
        ...this.state.importarCotizacionFormValues,
        selectedRowKeys: selected
      }
    }, () => {
      var detalleProductos = [];
      productos.forEach(producto => {
        detalleProductos.push(producto);
      });

      this.state.onSetFieldsValue({
        //idCliente: formValues.idCliente !== 0 ? { key: formValues.idCliente} : undefined,
        //idEstablecimientoCliente: formValues.idEstablecimientoCliente !== 0 ? { key: formValues.idEstablecimientoCliente } : undefined,
        //documentoCliente: formValues.documentoCliente,
        //idEstablecimiento: { key: response.cotizacion.idEstablecimiento },
        idAlmacen: { key: response.cotizacion.idAlmacen },
        idListaPrecio: { key: response.cotizacion.idListaPrecio },
        idMoneda: { key: response.cotizacion.idMoneda },
        otroImpuesto: { key: response.cotizacion.tipoImpuesto },
        idProyecto: { key: response.cotizacion.idProyecto },

        detalleProductos: detalleProductos,
        idTipoComprobanteImportado: response.cotizacion.idTipoComprobante,
        sumaTotalDetalle: obj.sumaTotalDetalle,
        sumaImporteDescuento: obj.sumaImporteDescuento,
        sumaSubTotal: obj.sumaSubTotal,
        sumaIgv: obj.sumaIgv,
        sumaIsc: obj.sumaIsc,
        sumaTotal: obj.sumaTotal,
      });
    });
  }




  handleImportarGuiaRemision = async (onSetFieldsValue, onGetFieldValue) => {
    this.setState(
      {
        onSetFieldsValue,
        onGetFieldValue,
      },
      async () => {
        var idCliente = this.state.onGetFieldValue("idCliente");

        if (idCliente === undefined) {
          dialog.error("Debe seleccionar un Cliente");
          return;
        }
        var filter = {
          idCliente: idCliente.key,
          serie: "",
          documento: "",
        };

        var response = await guiaRemisionService.importarRegistrados(filter);

        this.setState({
          importarGuiaRemisionVisible: true,
          importarGuiaRemision: {
            dataSource: response,
          },
        });
      }
    );
  };

  handleSelectGuiaRemision = async (row) => {

    var response = await guiaRemisionService.importarPorId({ id: row.id });

    if (response === undefined) {
      dialog.error("Ocurrió un error mientras se obtenia los datos.");
      return;
    }

    var productos = [];
    var listaComprobanteDetalle = [];
    var listaComprobanteReferencia = [];

    response.guiaRemisionDetalles.forEach((element) => {
      const identifier = global.fetchUniqueCode();

      listaComprobanteDetalle.push({
        identifier: identifier,
        idProducto: element.idProducto,
        idTipoProducto: 1,
        codigo: element.codigoReferencia,
        nombre: element.nombre,
        numeroLote: element.numeroLote,
        nombreUnidadMedida: element.nombreUnidadMedida,
        flagAfecto: element.flagAfecto,
        flagGratuito: element.flagGratuito,
        flagISC: element.flagISC,
        isc: element.importeISC,
        precioUnitarioSinIGV: element.precioUnitario,
        precioUnitario: element.precioUnitario,
        cantidad: element.cantidad,
        totalDetalle: element.subTotal.toFixed(2),
        porcentajeDescuento: 0,
        importeDescuento: 0,
        precioPromedio: element.precioPromedio,
        porcentajeMargenComercial: 0,
        subTotal: element.subTotal,
        igv: element.igv,
        idImpuesto: element.idImpuesto,
        total: element.total,
      });

      productos.push({
        identifier: identifier,
        idProducto: element.idProducto,
        idTipoProducto: 1,
        nombre: element.nombre,
        numeroLote: element.numeroLote,
        cantidad: element.cantidad,
        precioUnitarioSinIGV: element.precioUnitario,
        precioUnitario: element.precioUnitario,
        porcentajeDescuento: 0,
        importeDescuento: 0,
        precioPromedio: element.precioPromedio,
        porcentajeMargenComercial: 0,
        total: element.total,
        flagAfecto: element.flagAfecto,
        flagISC: false,
        flagOtrosImpuesto: false,
        flagGratuito: false,
        flagChangeTotal: false,
        idImpuesto: element.idImpuesto,
        subTotal: element.subTotal,
      });
    });

    listaComprobanteReferencia.push({
      identifier: global.fetchUniqueCode(),
      idReferencia: response.guiaRemision.id,
      flagInterno: true,
      idReferenciaOrigen: VENTAS_GUIA_REMISION,
      idTipoComprobante: response.guiaRemision.idTipoComprobante,
      serie: response.guiaRemision.serie,
      documento: response.guiaRemision.documento,
    });

    const almacenes = await await almacenService.listarPorIdEstablecimiento(
      response.guiaRemision.idEstablecimiento
    );
    const listasPrecio = this.state.listasPrecio.filter(
      (m) => m.idEstablecimiento === response.guiaRemision.idEstablecimiento
    );
    var formValues = {
      ...this.state.formValues,
      almacenes: almacenes,
      listasPrecio: listasPrecio,
      //idEstablecimiento: response.guiaRemision.idEstablecimiento,
      //idAlmacen: response.guiaRemision.idAlmacen,
      //idMoneda: response.guiaRemision.idMoneda,
      //idListaPrecio: response.guiaRemision.idListaPrecio,
      listaComprobanteDetalle: listaComprobanteDetalle,
      listaComprobanteReferencia: listaComprobanteReferencia,
    };

    if (
      (formValues.idCliente === 0 || formValues.idCliente === undefined) &&
      response.guiaRemision.idCliente !== null &&
      response.guiaRemision.idCliente !== undefined &&
      formValues.clientes.filter(
        (m) => m.id === response.guiaRemision.idCliente
      ).length !== 0
    ) {
      const direcciones = await establecimientoService.listarPorIdEntidad(
        response.guiaRemision.idEntidadCliente
      );
      formValues.documentoCliente =
        response.guiaRemision.numeroDocumentoEntidad;
      formValues.idCliente = response.guiaRemision.idCliente;
      formValues.direcciones = direcciones;
      formValues.idEstablecimientoCliente = direcciones[0].id;
      formValues.direccionCliente = direcciones[0].direccion;
    }

    this.setState(
      {
        almacenes: formValues.almacenes,
        listasPrecio: formValues.listasPrecio,
        direcciones: formValues.direcciones,
        formValues: formValues,
      },
      () => {
        var detalleProductos = [];
        productos.forEach((producto) => {
          detalleProductos.push(producto);
        });

        this.state.onSetFieldsValue({
          //idCliente: formValues.idCliente !== 0? { key: formValues.idCliente }: undefined,
          //idEstablecimientoCliente:formValues.idEstablecimientoCliente !== 0? { key: formValues.idEstablecimientoCliente }: undefined,
          //documentoCliente: formValues.documentoCliente,
          // idEstablecimiento: { key: response.guiaRemision.idEstablecimiento },
          // idAlmacen: { key: response.guiaRemision.idAlmacen },
          // idMoneda: { key: response.guiaRemision.idMoneda },
          // idListaPrecio: { key: response.guiaRemision.idListaPrecio },
          detalleProductos: detalleProductos,
          idTipoComprobanteImportado: response.guiaRemision.idTipoComprobante,
          sumaTotalDetalle: response.guiaRemision.subTotal,
          sumaImporteDescuento: 0,
          sumaSubTotal: response.guiaRemision.subTotal,
          sumaIgv: response.guiaRemision.igv,
          sumaIsc: 0,
          sumaTotal: response.guiaRemision.total,
        });
      }
    );
  };

  fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
    const filter = (tiposCambioDiario
      ? tiposCambioDiario
      : this.state.tiposCambioDiario
    ).filter((m) => m.idMoneda === idMoneda);
    if (filter.length > 0) return parseFloat(filter[0].venta).toFixed(3);
    else return "0.000";
  };

  handleChangeForm = async (property, value, form) => {

    if (property === "fechaStr") {
      const fecha = moment(value, "DD/MM/YYYY");
      const fechaVencimiento = moment(
        form.getFieldValue("fechaVencimientoStr"),
        "DD/MM/YYYY"
      );
      const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(
        value
      );

      form.setFieldsValue({
        tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
        diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
      });
    }

    if (property === "idCliente") {
      const direcciones = await establecimientoService.listarPorIdEntidad(value.split("-")[0]);
      var vehiculos = await vehiculoService.obtenerPorClienteId(value.split("-")[1]);
      vehiculos = vehiculos.filter(e => e.flag);

      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            direcciones: direcciones ? direcciones : [],
            vehiculos: vehiculos ? vehiculos : [],
            documentoCliente: form.getFieldValue("documentoCliente")

          },
        },
        () => {
          form.setFieldsValue({
            idEstablecimientoCliente: {
              key: direcciones.length > 0 ? direcciones[0].id : undefined,
            },
            direccionCliente: direcciones.length > 0 ? direcciones[0].direccion : ""
          });
        }
      );
    }

    if (property === "idCultivo") {
      const fenologicas = await fenologicaService.obtenerPorCultivoId(value);
      this.setState({
        formValues: {
          ...this.state.formValues,
          fenologicas: fenologicas ? fenologicas : [],
        }
      },
        () => {
          form.setFieldsValue({
            idFenologica: {
              key: undefined,
            },
          });
        }
      );
    }

    if (property === "idMedidaAnticipo") {
      var listaComprobanteDetalle = [];




      dialog.confirm("¿Desea cambiar unidad de medida de anticipo?", async () => {

        this.handleAnticipoClear(form);


        var item = {
          identifier: global.fetchUniqueCode(),
          idProducto: 8,
          idTipoProducto: value == 2 ? 2 : 1,
          nombre: 'Anticipo',
          nombreUnidadMedida: value == 2 ? 'UNIDAD (SERVICIOS)' : 'UNIDAD (BIENES)',
          flagAfecto: true,
          flagGratuito: false,
          flagExonerado: false,
          flagISC: false,
          isc: 0,
          precioUnitario: 0,
          cantidad: 0,
          totalDetalle: 0,
          porcentajeDescuento: 0,
          porcentajeMargenComercial: 0,
          precioPromedio: 0,
          importeDescuento: 0,
          subTotal: 0,
          idImpuesto: 1,
          igv: 0,
          total: 0,
          numeroLote: '',
          stock: 100,
          isItemLibre: false,
          itemConversion: []
        };

        listaComprobanteDetalle.push(item);

        this.setState({
          formValues: {
            ...this.state.formValues,
            listaComprobanteDetalle: listaComprobanteDetalle
          }
        }, () => {
          var producto = {
            identifier: item.identifier,
            idTipoProducto: item.idTipoProducto,
            idProducto: item.idProducto,
            nombre: item.nombre,
            cantidad: item.cantidad,
            precioUnitarioSinIGV: 0,
            porcentajeMargenComercial: item.porcentajeMargenComercial,
            precioPromedio: item.precioPromedio,
            precioUnitario: item.precioUnitario,
            porcentajeDescuento: item.porcentajeDescuento,
            importeDescuento: item.importeDescuento,
            total: item.total,
            flagAfecto: item.flagAfecto,
            flagExonerado: item.flagExonerado,
            flagISC: item.flagISC,
            flagOtrosImpuesto: false,
            flagGratuito: item.flagGratuito,
            flagChangeTotal: false,
            subTotal: 0,
            idImpuesto: item.idImpuesto,
            numeroLote: item.numeroLote,
            isItemLibre: false,
            itemConversion: []
          };

          var detalleProductos = form.getFieldValue('detalleProductos');
          detalleProductos.push(producto);
          form.setFieldsValue({
            detalleProductos: detalleProductos
          });
        });


      },
        async () => {

          this.setState({
            formValues: {
              ...this.state.formValues,
              flagAnticipo: true,
              //idMedidaAnticipo: value == 1 ? 2 : 1
            },
          });

          form.setFieldsValue({
            flagAnticipo: true,
            //idMedidaAnticipo: value == 1 ? 2 : 1

          });

        }
      );
      return false;
    }

    if (property === "idMoneda") {

      var cuentas = this.state.cuentas.filter(e => e.idMoneda == value);

      this.setState({
        formValues: {
          ...this.state.formValues,
          idMoneda: value,
          listaComprobanteMetodoPago: [],
          cuentas: cuentas
        }
      });
      form.setFieldsValue({
        codigoMoneda: value == SOLES ? "PEN" : "USD",
      });

    }
    if (property == "otroImpuesto") {
      var data = form.getFieldValue(property);

      if (this.state.formValues.listaComprobanteDetalle.length > 0) {

        dialog.confirm(
          <span>
            Al cambiar el tipo de impuesto se removera los productos agregados previamente.
            <br />
            <span>¿Deseas continuar?'</span>
          </span>,
          async () => {

            this.setState({
              formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: [],
                detalleProductos: [],
                listaComprobanteCuota: [],
                listaComprobanteReferencia: [],
              },
            });
            form.setFieldsValue({
              sumaTotalDetalle: 0,
              sumaImporteDescuento: 0,
              sumaSubTotal: 0,
              sumaIgv: 0,
              sumaIsc: 0,
              sumaTotal: 0,
              porcentajeDetraccion: 0,
              importeDetraccion: 0,
              totalDetraccion: 0,
              porcentajePercepcion: 0,
              importePercepcion: 0,
              totalPercepcion: 0,
              detalleProductos: [],
              listaComprobanteDetalle: [],
              flagAnticipo: 0
            });
          },
          () =>
            form.setFieldsValue({
              [property]: data,
            })
        );
      }
    }
    if (property === "idPendiente") {
      //1 contado
      var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;


      if (listaComprobanteMetodoPago.length > 0 && value == 1) { // PENDIENTE

        dialog.confirm("Al cambiar el estado se eliminaran el Método de Pago \n ¿Esta seguro de realizar la acción?", () => {

          this.setState({
            formValues: {
              ...this.state.formValues,
              listaComprobanteMetodoPago: [],
              idPendiente: value,

            }
          });

        }, () => {

          this.setState({
            formValues: {
              ...this.state.formValues,
              idPendiente: 2,

            }
          });

        }

        );


      } else {
        this.setState({
          formValues: {
            ...this.state.formValues,
            idPendiente: (value === 1 ? 1 : 2),

          },
        });
      }




      this.setState({ isPendienteSi: value == 1 ? false : true });

    }

    if (property === "flagContingencia") {
      if (value) {
        this.setState({
          formValues: {
            ...this.state.formValues,
            flagContingencia: value,
            flagDisableSerieDocumento: false,
          },
        });
      } else {
        const datosIniciales = await comprobanteService.datosIniciales({
          idUsuario: auth.user().id,
          idTipoComprobante: BOLETA_DE_VENTA.ID,
        });
        const serie = [undefined, null].includes(datosIniciales?.serie)
          ? ""
          : datosIniciales.serie;
        var fechaActual = global.fetchCurrentDateStr();
        this.setState(
          {
            formValues: {
              ...this.state.formValues,
              flagDisableSerieDocumento: true,
              fechaStr: fechaActual,
              flagDisableFecha:
                auth
                  .user()
                  .parametros.filter((m) => m.abreviatura === VALIDAR_STOCK)[0]
                  .valor === "1"
                  ? true
                  : false,
              serie: serie,
              documento: "",
            },
          },
          () => {
            form.setFieldsValue({
              fechaStr: moment(fechaActual, "DD/MM/YYYY"),
            });
          }
        );
      }
    }

    if (property === "flagPermisoFC") {
      if (value) {
        this.setState({
          formValues: {
            ...this.state.formValues,
            flagDisableFecha: false
          }
        })
      } else {
        this.setState({
          formValues: {
            ...this.state.formValues,
            flagDisableFecha: true
          }
        })
      }
    }
    if (property === "direcciones-clear") {
      this.setState({
        formValues: {
          ...this.state.formValues,
          idCliente: undefined,
          idEstablecimientoCliente: undefined,
          documentoCliente: "",
          direcciones: [],
          idVehiculo: undefined,
          encargado: '',
        },
      });
    }

    if (
      property === "idEstablecimiento" ||
      property === "idListaPrecio" ||
      property === "idAlmacen"
    ) {

      var _amazonia = this.state.formValues.establecimientos.filter(data => data.id == value);
      var flagAmazonia = _amazonia.length > 0 ? _amazonia[0].flagAmazonia : false;

      var data = form.getFieldValue(property);
      var label = property === "idEstablecimiento" ? "el establecimiento" : property === "idListaPrecio" ? "la lista de precio" : "el almacén";
      if (this.state.formValues.listaComprobanteDetalle.length > 0) {
        dialog.confirm(
          <span>
            Al cambiar {label} se removera los productos agregados previamente.
            <br />
            <span>¿Deseas continuar?'</span>
          </span>,
          async () => {
            if (property === "idEstablecimiento") {
              this.setState({
                formValues: { ...this.state.formValues, almacenLoading: true, flagAmazonia },
              });
              const almacenes = await almacenService.listarPorIdEstablecimiento(value);
              var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);

              if (almacenFilter != undefined && this.state.permisosUsuario.length > 0) {
                var newArray = new Array();
                this.state.permisosUsuario.forEach(e => {
                  var regg = almacenFilter.filter(data => data.id == e.idAlmacen);
                  if (regg.length > 0) {
                    var item = {
                      direccion: regg[0].direccion,
                      id: regg[0].id,
                      idTipoAlmacen: regg[0].idTipoAlmacen,
                      nombre: regg[0].nombre
                    }
                    newArray.push(item);
                  }

                });
                almacenFilter = newArray;
              }

              const listasPrecio = this.state.listasPrecio.filter(
                (m) => m.idEstablecimiento === value
              );

              this.setState({
                formValues: {
                  ...this.state.formValues,
                  almacenLoading: false,
                  almacenes: almacenes ? almacenes : [],
                  listasPrecio: listasPrecio ? listasPrecio : []
                },
              });
              form.setFieldsValue({
                idAlmacen: undefined,
                idListaPrecio: undefined,
                flagAmazonia: flagAmazonia,
                flagAmazoniaBien: false,
                flagAmazoniaServicio: false
              });
            }

            this.setState({
              formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: [],
                detalleProductos: [],
                listaComprobanteReferencia: [],
              },
            });
            form.setFieldsValue({
              sumaTotalDetalle: 0,
              sumaImporteDescuento: 0,
              sumaSubTotal: 0,
              sumaIgv: 0,
              sumaIsc: 0,
              sumaTotal: 0,
              porcentajeDetraccion: 0,
              importeDetraccion: 0,
              totalDetraccion: 0,
              porcentajePercepcion: 0,
              importePercepcion: 0,
              totalPercepcion: 0,
              detalleProductos: []
            });
          },
          () =>
            form.setFieldsValue({
              [property]: data,
            })
        );
      } else {
        if (property === "idEstablecimiento") {
          this.setState({
            formValues: { ...this.state.formValues, almacenLoading: true, flagAmazonia },
          });
          const almacenes = await almacenService.listarPorIdEstablecimiento(value);
          var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);

          if (almacenFilter != undefined && this.state.permisosUsuario.length > 0) {
            var newArray = new Array();
            this.state.permisosUsuario.forEach(e => {
              var regg = almacenFilter.filter(data => data.id == e.idAlmacen);
              if (regg.length > 0) {
                var item = {
                  direccion: regg[0].direccion,
                  id: regg[0].id,
                  idTipoAlmacen: regg[0].idTipoAlmacen,
                  nombre: regg[0].nombre
                }
                newArray.push(item);
              }

            });
            almacenFilter = newArray;
          }

          const listasPrecio = this.state.listasPrecio.filter(
            (m) => m.idEstablecimiento === value
          );
          this.setState({
            formValues: {
              ...this.state.formValues,
              almacenLoading: false,
              almacenes: almacenFilter ? almacenFilter : [],
              listasPrecio: listasPrecio ? listasPrecio : [],
            },
          });
          form.setFieldsValue({
            idAlmacen: undefined,
            idListaPrecio: undefined,
            detalleProductos: [],
            flagAmazonia: flagAmazonia,
            flagAmazoniaBien: false,
            flagAmazoniaServicio: false
          });
        }


        this.setState({
          formValues: {
            ...this.state.formValues,
            listaComprobanteDetalle: [],
            detalleProductos: [],
            listaComprobanteReferencia: [],
          },
        });
      }
    }
  };

  //#region  importar documento anticipo 
  handleAnticipoClear = (form) => {

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteDetalle: []

      }
    });


    form.setFieldsValue({
      sumaImporteDescuento: 0,
      sumaIsc: 0,
      sumaTotal: 0,
      sumaSubTotal: 0,
      sumaIgv: 0,
      sumaTotalDetalle: 0,
      importeDescuentoGlobal: 0,
      porcentajeDescuentoGlobal: 0,
      detalleProductos: [],
      porcentajePercepcion: 0,
      importePercepcion: 0,
      totalPercepcion: 0,
      porcentajeDetraccion: 0,
      importeDetraccion: 0,
      totalDetraccion: 0,
      importeRetencion: 0,
      totalRetencion: 0,
    });

  }
  handleAnticipo = async (row, form, idTipoServicio) => {

    var listaComprobanteDetalle = [];
    var lstMedida = this.state.unidadesMedida.length === 0 ? await unidadMedidaService.listar() : this.state.unidadesMedida;

    if (!row) {
      this.setState({
        formValues: {
          ...this.state.formValues,
          listaComprobanteDetalle: [],
          unidadesMedida: lstMedida

        },
        unidadesMedida: lstMedida

      });

      form.setFieldsValue({
        detalleProductos: []
      });
      return false;
    }

    if (idTipoServicio === undefined) {
      idTipoServicio = 2;


    }

    dialog.confirm("¿Desea agregar como anticipo?", async () => {

      this.handleAnticipoClear(form)

      var item = {
        identifier: global.fetchUniqueCode(),
        idProducto: 8,
        idTipoProducto: idTipoServicio == 2 ? 2 : 1,
        nombre: 'Anticipo',
        nombreUnidadMedida: idTipoServicio == 2 ? 'UNIDAD (SERVICIOS)' : 'UNIDAD (BIENES)',
        flagAfecto: true,
        flagGratuito: false,
        flagExonerado: false,
        flagISC: false,
        isc: 0,
        precioUnitario: 0,
        precioUnitarioSinIGV: 0,
        cantidad: 0,
        totalDetalle: 0,
        porcentajeDescuento: 0,
        porcentajeMargenComercial: 0,
        precioPromedio: 0,
        importeDescuento: 0,
        subTotal: 0,
        igv: 0,
        total: 0,
        numeroLote: '',
        stock: 1,
        itemConversion: []
      };

      listaComprobanteDetalle.push(item);

      this.setState({
        formValues: {
          ...this.state.formValues,
          listaComprobanteDetalle: listaComprobanteDetalle,
          unidadesMedida: lstMedida

        }
      }, () => {
        var producto = {
          identifier: item.identifier,
          idTipoProducto: item.idTipoProducto,
          idProducto: item.idProducto,
          nombre: item.nombre,
          cantidad: item.cantidad,
          precioUnitarioSinIGV: 0,
          porcentajeMargenComercial: item.porcentajeMargenComercial,
          precioPromedio: item.precioPromedio,
          precioUnitario: item.precioUnitario,
          porcentajeDescuento: item.porcentajeDescuento,
          importeDescuento: item.importeDescuento,
          total: item.total,
          flagAfecto: item.flagAfecto,
          flagExonerado: item.flagExonerado,
          flagISC: item.flagISC,
          flagOtrosImpuesto: false,
          flagGratuito: item.flagGratuito,
          flagChangeTotal: false,
          subTotal: 0,
          numeroLote: row.numeroLote,
          itemConversion: []
        };

        var detalleProductos = form.getFieldValue('detalleProductos');
        detalleProductos.push(producto);
        form.setFieldsValue({
          detalleProductos: detalleProductos
        });
      });


    },
      async () => {

        this.setState({
          formValues: {
            ...this.state.formValues,
            flagAnticipo: false
          },
        });

        form.setFieldsValue({
          flagAnticipo: false
        });

      }
    );


  };



  handleImportarAnticipo = async (onSetFieldsValue, onGetFieldValue) => {
    debugger
    this.setState({
      onSetFieldsValue,
      onGetFieldValue
    }, async () => {
      var idCliente = this.state.onGetFieldValue('idCliente');
      if (idCliente === undefined) {
        dialog.error("Debe seleccionar un Cliente");
        return false;
      }
      var filter = {
        idCliente: idCliente === undefined ? 0 : idCliente.key,
        serie: '',
        documento: '',
      }

      var response = await comprobanteService.importarAnticipos(filter);
      var newData = response.filter(e => e.idTipoDocumento == 4); //BOLETA_DE_VENTA



      this.setState({
        importarAnticipoVisible: true,
        importarAnticipo: {
          ...this.state.importarAnticipo,
          dataSource: newData ? newData : [],
          selectedRowKeys: this.state.formValues.listaComprobanteReferencia.map(function (v) {
            return v.documento;
          })
        },
      });


    });
  };


  handleSelectAnticipo = async (value, row) => {
    var listaComprobanteReferencia = [];

    debugger
    /*        var formValues = {
               ...this.state.formValues,
               listaComprobanteReferencia: [],
               totalAnticipo: 0,
               flagRegularizacion: false,
               flagAnticipo: false,
               activeKey: '1',
           };
   
           this.setState({
               formValues: formValues
           }); */

    if (this.state.formValues.listaComprobanteDetalle.length > 0 && row.length > 0) {
      message.warning('Para regularizacion de anticipo primero se tiene que importar doc origen luego agregar el detalle.');

      return;
    }

    row.forEach(element => {

      listaComprobanteReferencia.push({
        identifier: global.fetchUniqueCode(),
        idReferencia: 1,
        flagInterno: true,
        idReferenciaOrigen: 0,
        idTipoComprobante: element.idTipoDocumento,
        serie: element.serie,
        importado: true,
        documento: element.documento
      });
    });

    var totalAnticipo = parseFloat(row.reduce((a, b) => a + (b["total"] || 0), 0));


    listaComprobanteReferencia = listaComprobanteReferencia.filter(m => value.filter(f => f === m.documento + '-' + m.serie).length);

    this.setState({
      formValues: {
        ...this.state.formValues,
        activeKey: '2',
        listaComprobanteReferencia: listaComprobanteReferencia,
        totalAnticipo: totalAnticipo,
        flagRegularizacion: true,
        flagAnticipo: false,
        selectedRowKeys: value,
        flagPago: false
      },
      importarAnticipo: {
        ...this.state.importarAnticipo,
        selectedRowKeys: value,
        listaComprobanteReferencia
      }
    });


  };

  //#endregion



  handleItemLibre = (row, form, idTipoServicio) => {

    var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;


    var item = {
      identifier: global.fetchUniqueCode(),
      idProducto: 8,
      idTipoProducto: idTipoServicio == 2 ? 2 : 1,
      nombre: 'ITEM LIBRE' + this.state.formValues.listaComprobanteDetalle.length,
      nombreUnidadMedida: idTipoServicio == 2 ? 'UNIDAD (SERVICIOS)' : 'UNIDAD (BIENES)',
      flagAfecto: true,
      flagGratuito: false,
      flagExonerado: false,
      flagISC: false,
      isc: 0,
      precioUnitario: 0,
      precioUnitarioSinIGV: 0,
      cantidad: 0,
      totalDetalle: 0,
      porcentajeDescuento: 0,
      porcentajeMargenComercial: 0,
      precioPromedio: 0,
      importeDescuento: 0,
      subTotal: 0,
      igv: 0,
      total: 0,
      numeroLote: '',
      stock: 0,
      idImpuesto: 1,
      idUnidadMedida: 58,
      isItemLibre: true,
    };

    listaComprobanteDetalle.push(item);

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteDetalle: listaComprobanteDetalle
      }
    }, () => {
      var producto = {
        identifier: item.identifier,
        idTipoProducto: item.idTipoProducto,
        idProducto: item.idProducto,
        nombre: item.nombre,
        cantidad: item.cantidad,
        precioUnitarioSinIGV: 0,
        porcentajeMargenComercial: item.porcentajeMargenComercial,
        precioPromedio: item.precioPromedio,
        precioUnitario: item.precioUnitario,
        porcentajeDescuento: item.porcentajeDescuento,
        importeDescuento: item.importeDescuento,
        total: item.total,
        flagAfecto: item.flagAfecto,
        flagExonerado: item.flagExonerado,
        flagISC: item.flagISC,
        flagOtrosImpuesto: false,
        flagGratuito: item.flagGratuito,
        flagChangeTotal: false,
        subTotal: 0,
        idImpuesto: item.idImpuesto,
        numeroLote: row.numeroLote
      };

      var detalleProductos = form.getFieldValue('detalleProductos');
      detalleProductos.push(producto);
      form.setFieldsValue({
        detalleProductos: detalleProductos
      });
    });

  };


  handleBuscarCliente = async (value, form) => {
    this.setState({
      formValues: { ...this.state.formValues, clienteLoading: true },
    });

    //const response = await padronReducidoService.boleta(value);
    var numberDocument = form.getFieldValue("documentoCliente");
    if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
      dialog.warning(<ul>Ingrese documento valido</ul>);

      return;
    }
    var response = numberDocument.length == 8 ? await padronReducidoService.obtenerDniApi(value) :
      await padronReducidoService.obtenerRucApi(value);
    if (response.status === 400) {
      dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
      this.setState({ formValues: { ...this.state.formValues, clienteLoading: false } });

      return;
    }
    var vehiculos = await vehiculoService.obtenerPorClienteId(response.data.idCliente);

    if (response.status === 200) {
      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            clienteLoading: false,
            direcciones: response.data.direcciones,
            vehiculos: vehiculos ? vehiculos : [],
            documentoCliente: numberDocument
          },
        },
        () => {
          form.setFieldsValue({
            clientes: response.data.clientes,
            idCliente:
              response.data.clientes.length > 0
                ? { key: response.data.clientes[0].id }
                : undefined,
            idEstablecimientoCliente:
              response.data.direcciones.length > 0
                ? { key: response.data.direcciones[0].id }
                : undefined,
            direccionCliente:
              response.data.direcciones.length > 0
                ? response.data.direcciones[0].direccion
                : ""
          });
        }
      );
    } else {
      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            clienteLoading: false,
            direcciones: [],
          },
        },
        () => {
          form.setFieldsValue({
            clientes: [],
            idCliente: undefined,
            idEstablecimientoCliente: undefined,
          });
        }
      );
    }
  };

  handleBuscarProducto = async (value, form) => {
    this.setState({
      loadingProduct: true
    })
    var idAlmacen = this.state.onGetFieldValue("idAlmacen");
    var idMoneda = this.state.onGetFieldValue("idMoneda");
    var idListaPrecio = this.state.onGetFieldValue("idListaPrecio");

    var filter = {
      idAlmacen: idAlmacen.key,
      idMoneda: idMoneda.key,
      idListaPrecio: idListaPrecio.key,
      codigoNombre: value,
    };

    var response = await productoService.stock(filter);


    this.setState({
      searchProductVisible: true,
      loadingProduct: false,
      searchProductFormValues: {
        ...this.state.searchProductFormValues,
        validarStock: response.validarStock,
        dataSource: response.productos,
      },
    }, () => {
      form.setFieldsValue({
        dataSource: response.productos
      });
    });
  };

  handleOpenSearchProductModal = async () => {
    var idAlmacen = this.state.onGetFieldValue("idAlmacen");
    var idMoneda = this.state.onGetFieldValue("idMoneda");
    var idListaPrecio = this.state.onGetFieldValue("idListaPrecio");

    if (idAlmacen === undefined || idAlmacen.key === 0) {
      message.warning("Por favor seleccione un almacén.");
      return;
    }

    if (idListaPrecio === undefined || idListaPrecio.key === 0) {
      message.warning("Por favor seleccione una lista de precio.");
      return;
    }

    var filter = {
      idAlmacen: idAlmacen.key,
      idMoneda: idMoneda.key,
      idListaPrecio: idListaPrecio.key,
    };

    var response = await productoService.stock(filter);
    //var lista_stock= response.productos.length > 0 ? response.productos.filter((m) => m.stock > 0):[]


    this.setState({
      searchProductVisible: true,
      searchProductFormValues: {
        ...this.state.searchProductFormValues,
        validarStock: response.validarStock,
        precioUnitInclyIGV: response.precioUnitInclyIGV,
        dataSource: response.productos
      },
    });
  };

  handleScaner = async (value, onSetFieldsValue, onGetFieldValue, onCalculateDetail) => {
    this.setState({
      onSetFieldsValue,
      onGetFieldValue,
    });
    debugger;

    var idAlmacen = this.state.onGetFieldValue('idAlmacen');
    var idMoneda = this.state.onGetFieldValue('idMoneda');
    var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');
    var flagTipoBusquedaScanner = this.state.onGetFieldValue('flagTipoBusquedaScanner') === undefined ? 0 : this.state.onGetFieldValue('flagTipoBusquedaScanner');

    if (idAlmacen === undefined) {
      message.warning('Por favor seleccione un almacén.');
      return;
    }

    if (idMoneda === undefined) {
      message.warning('Por favor seleccione la moneda.');
      return;
    }

    if (idListaPrecio === undefined) {
      message.warning('Por favor seleccione una lista de precio.');
      return;
    }

    var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

    if (this.state.agregarSerieVisible) { // SE AGREGA SERIE MENDIANTE EL POPUP ASIGNAR SERIE

      var filter_producto_detalle = listaComprobanteDetalle.filter((m) => m.idProducto === this.state.agregarSerieModal.idProducto)[0];

      if (filter_producto_detalle.listaDetalleSerie.filter(m => m.serie === value).length > 0) {
        message.warning('La serie ya ha sido agregada.');
        return;
      }

      var listaSerieProducto = await movimientoService.listarSeriesDisponiblesComprobante({ idAlmacen: idAlmacen.key, idProducto: this.state.agregarSerieModal.idProducto, numeroLote: filter_producto_detalle.numeroLote, idComprobante: this.state.formValues.id, idTipoComprobante: this.state.formValues.idTipoComprobante });
      var serieProducto = listaSerieProducto.filter(m => m.serie === value);

      if (serieProducto.length === 0) {
        message.warning('El número de serie no existe.');
        return;
      }

      filter_producto_detalle.listaDetalleSerie.push(serieProducto[0]);
      debugger;
      var selected = filter_producto_detalle.listaDetalleSerie.map(m => m.serie);

      this.handleChangeSelectedSerie(selected, filter_producto_detalle.listaDetalleSerie, onCalculateDetail, 0);

      return;
    }
    else if (flagTipoBusquedaScanner === 0) // BUSQUEDA DE PRODUCTO POR CODIGO DE BARRA
    {
      //SE AGREGA PRODUCTO POR CODIGO DE BARRA 

      var filter_detalle = listaComprobanteDetalle.filter((m) => m.codigoBarra === value);

      const index = listaComprobanteDetalle.map(i => i.codigoBarra).indexOf(value);

      var item = {};
      if (filter_detalle.length > 0) {
        listaComprobanteDetalle = listaComprobanteDetalle.filter((m) => m.codigoBarra !== value);

        var item = filter_detalle[0];

        if (item.flagAplicarSerie) {
          dialog.error("El producto ya se encuentra agregado.");
          return;
        }

        var item = filter_detalle[0];
        var _precioUnitario = this.state.onGetFieldValue(`arrPrecioUnitario[${item.identifier}]`);
        var _cantidad = this.state.onGetFieldValue(`arrCantidad[${item.identifier}]`);

        item.cantidad = parseInt(_cantidad,) + 1;

        item.precioUnitario = parseFloat(_precioUnitario);
      } else {

        var filter = {
          idAlmacen: idAlmacen.key,
          idMoneda: idMoneda.key,
          idListaPrecio: idListaPrecio.key,
          codigoNombre: value,
        }

        var list = await productoService.stock(filter);

        var filter_list = list.productos.filter((m) => m.codigoBarra === value);

        if (filter_list.length === 0) {
          dialog.error("No existe el producto con codigo " + value + "\n" + "o no cuenta con stock");
          return;
        }

        item = this.setDetalleByProductoStock(filter_list[0]);
      }

      listaComprobanteDetalle.splice(index, 0, item);

      var detalleProductos = this.state.onGetFieldValue("detalleProductos");
      detalleProductos = detalleProductos.filter((m) => m.identifier !== item.identifier);

      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            listaComprobanteDetalle: listaComprobanteDetalle
          },
        },
        () => {
          detalleProductos.splice(index, 0, item);
          this.state.onSetFieldsValue({
            detalleProductos: detalleProductos
          });
          onCalculateDetail(item, "arrCantidad", item.cantidad, 3, index);
        }
      );
      message.success("Producto agregado");
    }
    else if (flagTipoBusquedaScanner === 1)  // BUSQUEDA DE PRODUCTO POR SERIE
    {
      debugger;
      var listaSerieProducto = await movimientoService.listarSeriesDisponiblesBySerieComprobante({ idAlmacen: idAlmacen.key, serie: value, idComprobante: this.state.formValues.id, idTipoComprobante: this.state.formValues.idTipoComprobante });

      if (listaSerieProducto.length === 0) {
        message.warning('El número de serie no existe.');
        return;
      }

      var count_productos_by_serie = listaSerieProducto.map(item => item.idProducto).filter((value, index, self) => self.indexOf(value) === index);

      if (count_productos_by_serie.length > 1) {
        message.warning('La serie tiene asociado mas de un producto, no se puede escanear.');
        return;
      }

      var serieProducto = listaSerieProducto[0];

      var comprobanteDetalle_filter = listaComprobanteDetalle.filter(m => m.idProducto === serieProducto.idProducto && m.numeroLote == serieProducto.numeroLote);
      debugger;
      var item = {};
      if (comprobanteDetalle_filter.length > 0) {
        item = comprobanteDetalle_filter[0];

        if (item.listaDetalleSerie.filter(m => m.serie === value).length > 0) {
          message.warning('La serie ya ha sido agregado.');
          return;
        }

        var _precioUnitario = this.state.onGetFieldValue(`arrPrecioUnitario[${item.identifier}]`);
        var _cantidad = this.state.onGetFieldValue(`arrCantidad[${item.identifier}]`);

        item.cantidad = parseInt(_cantidad,) + 1;
        item.listaDetalleSerie.push(serieProducto);
        item.precioUnitario = parseFloat(_precioUnitario);

        var listaComprobanteDetalleFilter = listaComprobanteDetalle.filter(m => m.identifier != item.identifier);

        listaComprobanteDetalleFilter.push(item);

        listaComprobanteDetalle = listaComprobanteDetalleFilter;

      } else {
        var filter = {
          idAlmacen: idAlmacen.key,
          idMoneda: idMoneda.key,
          idListaPrecio: idListaPrecio.key,
          codigoNombre: ''
        }

        const response = await productoService.stock(filter);

        var producto = response.productos.filter(m => m.id === serieProducto.idProducto && m.numeroLote === serieProducto.numeroLote)[0];

        item = this.setDetalleByProductoStock(producto);

        item.listaDetalleSerie.push(serieProducto);
        item.detalleSeries = item.listaDetalleSerie.map(u => u.serie).join(', ');
        item.cantidad = item.listaDetalleSerie.length;

        listaComprobanteDetalle.push(item);
      }

      var selected = item.listaDetalleSerie.map(m => m.serie);

      var detalleProductos = this.state.onGetFieldValue("detalleProductos");

      const index = listaComprobanteDetalle.map(i => i.identifier).indexOf(item.identifier);

      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            listaComprobanteDetalle: listaComprobanteDetalle
          },
        },
        () => {
          detalleProductos.push(item);
          this.state.onSetFieldsValue({
            detalleProductos: detalleProductos
          });

          this.handleChangeSelectedSerie(selected, item.listaDetalleSerie, onCalculateDetail, 0, index);
        }
      );
    }


  };

  setDetalleByProductoStock = (row) => {
    var item = {
      identifier: global.fetchUniqueCode(),
      idProducto: row.id,
      idTipoProducto: row.idTipoProducto,
      codigo: row.codigoReferencia,
      codigoBarra: row.codigoBarra,
      nombre: row.nombre,
      nombreUnidadMedida: row.nombreUnidadMedida,
      porcentajeMargenComercial: row.porcentajeMargenComercial,
      precioPromedio: row.precioPromedio,
      flagAplicarSerie: row.flagAplicarSerie,
      flagAfecto: row.flagIGVAfecto,
      flagGratuito: row.flagGratuito,
      flagISC: row.flagISC,
      flagExonerado: row.flagExonerado,
      isc: 0,
      precioUnitario: row.precioUnitario,
      cantidad: 1,
      totalDetalle: 0,
      porcentajeDescuento: 0,
      importeDescuento: 0,
      subTotal: 0,
      igv: 0,
      total: 0,
      numeroLote: row.numeroLote,
      stock: row.stockDisponible,
      idUnidadMedida: 0,
      isItemLibre: false,
      flagConversion: false,
      itemConversion: [],
      listaDetalleSerie: []
    };
    return item;
  };


  onCalculateMetodoPago = (totalCompra) => {
    var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;

    if (listaComprobanteMetodoPago.length == 1) {
      var newPago = [];

      listaComprobanteMetodoPago.forEach((key) => {
        newPago.push({
          identifier: key.identifier,
          fechaPago: key.fechaPago,
          idMetodoPago: key.idMetodoPago, //efectivo
          idCuenta: key.idCuenta,
          referencia: key.referencia,
          montoPago: totalCompra
        });

      });

      this.setState({
        formValues: {
          ...this.state.formValues,
          listaComprobanteMetodoPago: newPago
        }
      });

    }

  }

  calculateDescuento = async (descuento, PorcentajeDescuento, form) => {
    if (descuento !== undefined) {
      this.setState({
        formValues: {
          ...this.state.formValues,
          importeDescuentoGlobal: descuento,
          porcentajeDescuentoGlobal: PorcentajeDescuento
        }
      });

      form.setFieldsValue({
        importeDescuentoGlobal: parseFloat(descuento.toFixed(2)),
        porcentajeDescuentoGlobal: parseFloat(PorcentajeDescuento.toFixed(2)
        ),
      });
    }


  }


  handleSelectProduct = async (row) => {
    var params = auth.user().parametros;
    var idListaPrecio = this.state.onGetFieldValue("idListaPrecio").key;
    var flagAmazonia = this.state.onGetFieldValue("flagAmazonia");

    var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
    var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;
    var empresa_salud = this.state.company.idTipoEmpresa == 3 ? true : false;
    var producto_lote = params.filter((m) => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;

    var listaPrecio = 0;
    var itemsConversion = [];

    if (conversionMedida) {
      itemsConversion = await productoService.listarConversionProductoPorId(row.id);
      var lista_data = this.state.listasPrecio.filter((m) => m.id == idListaPrecio);
      listaPrecio = lista_data[0].idTipoListaPrecio;
    }
    // ✅ VALIDACIÓN DINÁMICA
    const existe = listaComprobanteDetalle.some(det => {
      if (producto_lote) {
        // valida producto + lote
        return det.idProducto === row.id &&
          det.numeroLote === row.numeroLote;
      }
      return false;
    });
    if (existe && producto_lote) {
      dialog.info("Este producto con el mismo lote ya fue agregado.");
      return;
    }

    var item = {
      identifier: global.fetchUniqueCode(),
      idProducto: row.id,
      idTipoProducto: row.idTipoProducto,
      codigo: row.codigoReferencia,
      nombre: empresa_salud
        ? row.nombre + ' (Lt. ' + row.numeroLote + '- FV ' + row.fechaVencimientoStr + ')'
        : row.nombre,
      nombreUnidadMedida: row.nombreUnidadMedida,
      flagAfecto: flagAmazonia ? false : row.flagIGVAfecto,
      flagGratuito: row.flagGratuito,
      flagAplicarSerie: row.flagAplicarSerie,
      flagExonerado: flagAmazonia ? true : row.flagExonerado,
      flagISC: row.flagISC,
      isc: 0,
      precioUnitario: row.precioUnitario,
      precioUnitarioSinIGV: 0,
      cantidad: 0,
      totalDetalle: 0,
      porcentajeDescuento: 0,
      porcentajeMargenComercial: row.porcentajeMargenComercial,
      precioPromedio: row.precioPromedio,
      importeDescuento: 0,
      subTotal: 0,
      igv: 0,
      total: 0,
      numeroLote: row.numeroLote,
      stock: row.stockDisponible,
      idUnidadMedida: 0,
      idImpuesto: row.idImpuesto,
      isItemLibre: false,
      itemConversion: itemsConversion ? itemsConversion : [],
      flagConversion: false,
      flagVencimiento: row.flagVencimiento,
      fechaVencimientoStr: row.flagVencimiento ? row.fechaVencimientoStr : null,
      listaDetalleSerie: [],
      selectedSerie: []
    };

    // ✅ agregar porque ya pasó validación
    listaComprobanteDetalle.push(item);

    this.setState({
      formValues: {
        ...this.state.formValues,
        idTipoPrecio: listaPrecio,
        listaComprobanteDetalle: listaComprobanteDetalle
      }
    }, () => {
      var producto = {
        identifier: item.identifier,
        idTipoProducto: item.idTipoProducto,
        idProducto: item.idProducto,
        nombre: item.nombre,
        cantidad: item.cantidad,
        precioUnitarioSinIGV: 0,
        porcentajeMargenComercial: item.porcentajeMargenComercial,
        precioPromedio: item.precioPromedio,
        precioUnitario: item.precioUnitario,
        porcentajeDescuento: item.porcentajeDescuento,
        importeDescuento: item.importeDescuento,
        total: item.total,
        flagAfecto: item.flagAfecto,
        flagExonerado: item.flagExonerado,
        flagISC: item.flagISC,
        flagOtrosImpuesto: false,
        flagGratuito: item.flagGratuito,
        flagChangeTotal: false,
        flagAplicarSerie: item.flagAplicarSerie,
        subTotal: 0,
        numeroLote: row.numeroLote,
        isItemLibre: false,
        idUnidadMedida: 0,
        idImpuesto: item.idImpuesto,
        itemConversion: itemsConversion ? itemsConversion : [],
        flagConversion: false,
        flagVencimiento: row.flagVencimiento,
        fechaVencimientoStr: row.flagVencimiento ? row.fechaVencimientoStr : null,
        listaDetalleSerie: [],
        selectedSerie: []
      };

      var detalleProductos = this.state.onGetFieldValue('detalleProductos');
      detalleProductos.push(producto);

      this.state.onSetFieldsValue({ detalleProductos });
      this.state.onSetFieldsValue({ idTipoPrecio: listaPrecio });
    });
  };

  handleSelectConversion = async (dataItem, value, index, identifier) => {

    var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter((m) => m.identifier !== identifier);

    var idAlmacen = this.state.onGetFieldValue("idAlmacen");
    var idMoneda = this.state.onGetFieldValue("idMoneda");
    var idListaPrecio = this.state.onGetFieldValue("idListaPrecio");

    var filter = {
      idAlmacen: idAlmacen.key,
      idMoneda: idMoneda.key,
      idListaPrecio: idListaPrecio.key,
      idProducto: dataItem.idProducto,
      idUnidadMedida: value,
      flagConversion: true
    };

    var row = await productoService.stock_conversionMedida(filter);



    dataItem.nombreUnidadMedida = '';
    dataItem.precioPromedio = row[0].precioPromedio;
    dataItem.precioUnitario = row[0].precioUnitario;
    dataItem.cantidad = 0;
    dataItem.precioUnitarioSinIGV = 0;
    dataItem.totalDetalle = 0;
    dataItem.porcentajeDescuento = 0;
    dataItem.importeDescuento = 0;
    dataItem.subTotal = 0;
    dataItem.igv = 0;
    dataItem.total = 0;
    dataItem.idUnidadMedida = value;
    dataItem.stock = row[0].stockDisponible;
    dataItem.flagConversion = true;
    listaComprobanteDetalle.splice(index, 0, dataItem);

    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          listaComprobanteDetalle: listaComprobanteDetalle,
        },
      },
      () => {

        var detalleFilter = this.state.onGetFieldValue("detalleProductos");
        var detalleProductos = detalleFilter.filter((m) => m.identifier !== identifier);
        detalleProductos.splice(index, 0, dataItem);
        this.state.onSetFieldsValue({
          detalleProductos,
          [`arrPrecioUnitario[${identifier}]`]: dataItem.precioUnitario,

        });
      }
    );
  };
  handleRemoverProducto = (row, form) => {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(
            (m) => m.identifier !== row.identifier
          ),
        },
      },
      () => {
        var detalleProductos = form.getFieldValue("detalleProductos");
        form.setFieldsValue({
          detalleProductos: detalleProductos.filter(
            (m) => m.identifier !== row.identifier
          ),
        });
      }
    );
  };

  handleEditarNombreProducto = (row, onSetFieldsValue, onGetFieldValue) => {
    var formValues = {
      id: row.identifier,
      nombre: onGetFieldValue(`arrNombre[${row.identifier}]`),
    };

    this.setState({
      editarNombreProductoVisible: true,
      editarNombreProductoFormValues: formValues,
      onSetFieldsValue,
      onGetFieldValue,
    });
  };

  handleSaveEditarNombreProducto = (values, form) => {
    var unidadMedida = this.state.onGetFieldValue(`arridUnidadMedida[${values.id}]`);

    form.resetFields();
    this.setState({ editarNombreProductoVisible: false });
    var detalleProductos = this.state.onGetFieldValue("detalleProductos");
    detalleProductos.forEach((item) => {
      if (item.identifier === values.id) {
        item.nombre = values.nombre;
        item.nombreUnidadMedida = unidadMedida.key == undefined ? unidadMedida.label : unidadMedida.key

        return;
      }
    });

    this.state.onSetFieldsValue({
      detalleProductos,
      [`arrNombre[${values.id}]`]: values.nombre,
      [`arridUnidadMedida[${values.id}]`]: { key: unidadMedida.key == undefined ? unidadMedida.label : unidadMedida.key },

    });
  };

  handleAddReferencia = () => {
    var listaComprobanteReferencia = this.state.formValues
      .listaComprobanteReferencia;

    listaComprobanteReferencia.push({
      identifier: global.fetchUniqueCode(),
      idReferencia: 0,
      idReferenciaOrigen: 0,
      idTipoComprobante: 0,
      serie: "",
      documento: "",
      flagInterno: false,
    });

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteReferencia: listaComprobanteReferencia,
      },
    });
  };

  handleRemoverReferencia = (item) => {
    var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(
      (m) => m.identifier !== item.identifier
    );
    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteReferencia: listaComprobanteReferencia,
      },
    });
  };



  handleRemoverMetodoPago = (item) => {
    var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago.filter(m => m.identifier !== item.identifier);
    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteMetodoPago: listaComprobanteMetodoPago
      }
    });
  };

  handleAddMetodoPago = () => {
    debugger
    var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;
    listaComprobanteMetodoPago.push({
      identifier: global.fetchUniqueCode(),
      fechaPago: global.fetchCurrentDateStr(),
      idMetodoPago: 0,
      idCuenta: 0,
      referencia: "",
      montoPago: 0
    });

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteMetodoPago: listaComprobanteMetodoPago
      }
    });
  };



  handleChangeTab = (key, onSetFieldsValue) => {

    if (key == "2") {
      // Referencias
      onSetFieldsValue({
        flagReferencia: true,
      });
    }
    if (key == "4") { // Metodo de Pago
      onSetFieldsValue({
        flagMetodoPago: true
      })
    }

    this.setState({
      formValues: {
        ...this.state.formValues,
        activeKey: key,
      },
    });
  };

  handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
    this.setState(
      {
        onSetFieldsValue,
        onGetFieldValue,
      },
      () => {
        if (this.state.formValues.activeKey === "1")
          this.handleOpenSearchProductModal();

        const newLocal = "2";
        if (this.state.formValues.activeKey === newLocal)
          this.handleAddReferencia();

        const formaPagos = "4";
        if (this.state.formValues.activeKey === formaPagos)
          this.handleAddMetodoPago();
      }
    );
  };

  handleView = async (item) => {
    this.setState({ loadingVer: true });
    var response = await comprobanteService.ver({ id: item.id });
    if (response !== undefined) {
      response.flagEmpresaGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;

      this.setState({
        loadingVer: false,
        viewVisible: true,
        viewFormValues: response,
      });
    }
  };

  handleOpenEmitirModal = async (item) => {
    debugger
    this.setState({ loadingEmitir: true });
    var visualizar = auth.user().parametros.filter(m => m.abreviatura === VENTA_VISUALIZACION_DOCUMENTOS)[0].valor === "1" ? true : false;
    if (visualizar) {
      var response = await comprobanteService.pdfA4({ id: item.id });
      var file = window.URL.createObjectURL(response.data);
      this.setState({
        loadingEmitir: false,
        emitirVisible: true,
        emitirFilePdf: file,
        selectedItem: item
      });
    } else {
      this.handleEmitir(item);
    }

  };

  handleEmitir = async (item) => {

    item = this.state.emitirVisible ? this.state.selectedItem : item;
    var flagEmitir = this.state.configuraciones.filter((m) => m.abreviatura === EMISION_COMPRO).length >= 1 ? true : false;

    if (flagEmitir) {
      dialog.confirm("¿Desea enviar el comprobante a sunat " + item.serieDocumentoComprobante + " ?", async () => {
        var response = await comprobanteService.emitir({ id: item.id });
        this.setState({ loadingEmitir: false });

        if (response.status === 200) {
          //form.resetFields();
          dialog.success(response.data);
          this._handlePagination(this.state.filter);
          this.setState({ emitirVisible: false });
          return;
        }

        if (response.status === 400) {
          dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
          return;
        }
        dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
      }, async () => { this.setState({ loadingEmitir: false }) });
      return;
    }
    this.setState({ loadingEmitir: false });
    message.warning('Usted no puede emitir comprobantes');

  };

  handleAnular = async (item) => {
    dialog.confirm(
      `¿Desea anular el comprobante ${item.serie}-${item.documento}?`,
      async () => {
        var response = await comprobanteService.anular({ id: item.id });

        if (response.status === 200) {
          dialog.success(
            `Comprobante ${item.serie}-${item.documento} anulado correctamente.`
          );
          this._handlePagination(this.state.filter);
          return;
        }

        if (response.status === 400) {
          dialog.warning(
            <ul>
              {response.data.messages.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
          );
          return;
        }

        dialog.error(
          "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
        );
      }
    );
  };

  handleImprimir = async (item) => {

    this.setState({ loadingImprimir: true });
    var file = undefined;
    var idFormato = this.state.company.formatoPrint;
    var isEpson = JSON.parse(localStorage.getItem("isEpson"));

    var response;
    if (idFormato === 1) {
      response = await comprobanteService.pdfA4({ id: item.id });
      file = window.URL.createObjectURL(response.data);
    }

    if (idFormato === 2) {
      response = await comprobanteService.ticket({
        id: item.id,
        isEpson: isEpson == null ? false : isEpson
      });
      file = window.URL.createObjectURL(response.data);
    }

    if (idFormato === 3) {
      response = await comprobanteService.ticket50({ id: item.id });
      file = window.URL.createObjectURL(response.data);
    }

    this.setState({
      imprimirVisible: true,
      loadingImprimir: false,
      imprimirFormValues: {
        ...this.state.imprimirFormValues,
        idFormato,
        file,
        idComprobante: item.id,
      },
      selectedItem: item,
    });
  };

  handleSwitch = async (e) => {
    localStorage.setItem("isEpson", JSON.stringify(e))
    this.setState({
      imprimirFormValues: {
        ...this.state.imprimirFormValues,
        isEpson: e,
      }
    })

    setTimeout(() => {
      this.handleChangeImprimir(2)
    }, 100);
  }

  handleChangeImprimir = async (idFormato) => {
    var file = undefined;
    var response = undefined;
    if (idFormato === 1) {
      response = await comprobanteService.pdfA4({
        id: this.state.imprimirFormValues.idComprobante,
      });
      file = window.URL.createObjectURL(response.data);
    }

    if (idFormato === 2) {

      response = await comprobanteService.ticket({
        id: this.state.imprimirFormValues.idComprobante,
        isEpson: JSON.parse(localStorage.getItem("isEpson")),
      });

      file = window.URL.createObjectURL(response.data);
    }

    if (idFormato === 3) {
      response = await comprobanteService.ticket50({
        id: this.state.imprimirFormValues.idComprobante,
      });
      file = window.URL.createObjectURL(response.data);
    }

    this.setState({
      imprimirFormValues: {
        ...this.state.imprimirFormValues,
        idFormato,
        file,
        isEpson: JSON.parse(localStorage.getItem("isEpson")),
      },
    });
  };

  handleCorreo = async (item) => {
    item.respuestaSunat = item.respuestaSunat && item.respuestaSunat.includes('1033') ? null : item.respuestaSunat;

    this.setState({ loadingCorreo: true });
    var file = undefined;
    var idFormato = this.state.company.formatoPrint;

    /*     if (idFormato === 1) {
          var response = await comprobanteService.pdfA4({ id: item.id });
          file = window.URL.createObjectURL(response.data);
        }
    
        if (idFormato === 2) {
          var response = await comprobanteService.ticket({ id: item.id });
          file = window.URL.createObjectURL(response.data);
        }
    
        if (idFormato === 3) {
          var response = await comprobanteService.ticket50({ id: item.id });
          file = window.URL.createObjectURL(response.data);
        } */




    this.setState({
      loadingCorreo: false,
      correoVisible: true,
      correoFormValues: {
        ...this.state.correoFormValues,
        file,
        idComprobante: item.id,
        idFormato: 1,
        correoCliente: item.correoCliente,
      },
    });

    if (item.respuestaSunat == null) {
      var response = await comprobanteService.getCdr({
        id: item.id,
        serie: item.serie,
        documento: item.documento,
        codigoTipoDocumento: item.tipoComprobante,
      });
    }


  };

  handleChangeCorreo = async (idFormato) => {
    var file = undefined;

    if (idFormato === 1) {
      var response = await comprobanteService.pdfA4({
        id: this.state.correoFormValues.idComprobante,
      });
      file = window.URL.createObjectURL(response.data);
    }

    if (idFormato === 2) {
      var response = await comprobanteService.ticket({
        id: this.state.correoFormValues.idComprobante,
      });
      file = window.URL.createObjectURL(response.data);
    }

    if (idFormato === 3) {
      var response = await comprobanteService.ticket50({
        id: this.state.correoFormValues.idComprobante,
      });
      file = window.URL.createObjectURL(response.data);
    }

    this.setState({
      correoFormValues: {
        ...this.state.correoFormValues,
        idFormato,
        file,
      },
    });
  };

  handleEnviarCorreo = async (data, form) => {
    dialog.confirm("¿Desea enviar el correo?", async () => {
      var response = await comprobanteService.enviarCorreo(data);

      if (response.status === 200) {
        form.resetFields();
        dialog.success("El correo ha sido enviado.");
        this.setState({ correoVisible: false });
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };

  contieneErroresSunat = (str) => {
    return ['1033', 'SendTimeout'].some(sub => str.includes(sub));
  };

  handleOpenCdrModal = async (row) => {

    row.respuestaSunat = row.respuestaSunat && this.contieneErroresSunat(row.respuestaSunat)
      ? null
      : row.respuestaSunat;

    this.setState({
      cdrVisible: true,
      selectedItem: row,
    });
  };

  handleDownloadXml = async () => {
    var response = await comprobanteService.xml({
      id: this.state.selectedItem.id,
    });
    if (response !== undefined)
      global.dowloadFile(response.data, this.state.selectedItem.nombreXML);
  };

  handleDownloadCdr = async () => {
    var response = await comprobanteService.cdr({
      id: this.state.selectedItem.id,
    });
    if (response !== undefined)
      global.dowloadFile(response.data, this.state.selectedItem.nombreCDR);
  };

  handleGetCdr = async () => {
    this.setState({
      loadingFile: true
    })
    var response = await comprobanteService.getCdr({
      id: this.state.selectedItem.id,
      serie: this.state.selectedItem.serie,
      documento: this.state.selectedItem.documento,
      codigoTipoDocumento: this.state.selectedItem.tipoComprobante,
    });
    if (response.status == 200) {
      dialog.success(response.data);

      this.setState({ cdrVisible: false })
    } else {
      dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);

    }
    this.setState({
      loadingFile: false
    })
  };


  handleDownloadPdf = async () => {

    var response = undefined;
    var file = undefined;
    /* 
        if (this.state.imprimirFormValues.idFormato === 1) {
          response = await comprobanteService.pdfA4({
            id: this.state.selectedItem.id,
          });
          file = window.URL.createObjectURL(response.data);
        }
    
        if (this.state.imprimirFormValues.idFormato === 2) {
          response = await comprobanteService.ticket({
            id: this.state.selectedItem.id,
          });
          file = window.URL.createObjectURL(response.data);
        }
    
        if (this.state.imprimirFormValues.idFormato === 3) {
          response = await comprobanteService.ticket50({
            id: this.state.selectedItem.id,
          });
          file = window.URL.createObjectURL(response.data);
        }
    
        if (response !== undefined)
          global.dowloadFile(
            response.data,
            this.state.selectedItem.serieDocumentoComprobante + ".pdf"
          ); */

    global.downloadFileBlob(this.state.imprimirFormValues.file, this.state.selectedItem.serieDocumentoComprobante + ".pdf");

  };

  fetchEmptyFormValuesCliente = () => {
    return {
      id: 0,
      idTipoPersona: 1,
      idTipoDocumento: DNI.ID,
      numeroDocumento: '',
      razonSocial: '',
      nombre: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      correo: '',
      idEstadoContribuyente: ACTIVO,
      idCondicionSunat: HABIDO,
      idTipoRelacion: 0,
      idVendedor: 0,
      nombreTipoEstablecimiento: '',
      telefono: '',
      idDepartamento: 0,
      idProvincia: 0,
      idUbigeo: 0,
      idPais: 0,
      direccion: '',
      /******************/
      searchLoading: false,
      flagPersonaJuridica: false,
      flagPersonaNatural: true,
      tiposPersona: [],
      tiposDocumento: [],
      condicionesSunat: [],
      estadosContribuyente: [],
      tiposEstablecimiento: [],
      tiposRelacion: [],
      vendedores: [],
      departamentos: [],
      provincias: [],
      distritos: [],
      paises: [],
    }
  };

  handleNewCliente = async (onSetFieldsValue, onGetFieldValue) => {
    this.setState({
      onSetFieldsValue,
      onGetFieldValue,
    });

    var formValuesCliente = this.fetchEmptyFormValuesCliente();
    var tipoEstablecimientoFiltered = this.state.tiposEstablecimiento.filter(m => m.id === DOMICILIO_FISCAL.ID);
    var tiposPersonaFiltered = this.state.tiposPersona.filter(m => m.codigo === NATURAL.CODIGO);

    formValuesCliente.tiposPersona = this.state.tiposPersona;
    formValuesCliente.paises = this.state.paises;
    formValuesCliente.tiposDocumento = this.state.tiposDocumento;
    formValuesCliente.condicionesSunat = this.state.condicionesSunat;
    formValuesCliente.estadosContribuyente = this.state.estadosContribuyente;
    formValuesCliente.tiposRelacion = this.state.tiposRelacion;
    formValuesCliente.vendedores = this.state.vendedores;
    formValuesCliente.departamentos = this.state.departamentos.length === 0 ? await ubigeoService.departamentos() : this.state.departamentos;
    formValuesCliente.idTipoPersona = tiposPersonaFiltered.length === 0 ? 0 : tiposPersonaFiltered[0].id
    formValuesCliente.nombreTipoEstablecimiento = tipoEstablecimientoFiltered.length === 0 ? '' : tipoEstablecimientoFiltered[0].nombre;

    this.setState({ visibleCliente: true, formValuesCliente });
  };

  handleChangeFormCliente = async (property, value) => {
    if (property === "idDepartamento") {
      const provincias = await ubigeoService.provincias(value);
      this.setState({
        formValuesCliente: {
          ...this.state.formValuesCliente,
          provincias: provincias ? provincias : [],
          distritos: []
        }
      });
    }

    if (property === "idProvincia") {
      const distritos = await ubigeoService.distritos(value);
      this.setState({
        formValuesCliente: {
          ...this.state.formValuesCliente,
          distritos: distritos ? distritos : []
        }
      });
    }

    if (property === "clear") {
      this.setState({
        formValuesCliente: {
          ...this.state.formValuesCliente,
          provincias: [],
          distritos: []
        }
      });
    }
  };

  handleSaveCliente = (values, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response;

      if (values.id === 0)
        response = await clienteService.registrar(values);
      else
        response = await clienteService.modificar(values);

      if (response.status === 200) {
        form.resetFields();

        const clientes = await clienteService.listar();
        var cliente = clientes.filter(m => m.id === response.data);

        const idEntidad = cliente.length > 0 ? cliente[0].idEntidad : 0;
        const direcciones = await establecimientoService.listarPorIdEntidad(idEntidad);


        var formValues = {
          ...this.state.formValues,
          clientes: clientes,
          direcciones: direcciones,
          idCliente: cliente[0].id,
          documentoCliente: cliente[0].numeroDocumento,
          idEstablecimientoCliente: direcciones[0].id,
        };

        this.setState({
          clientes: formValues.clientes,
          formValues: formValues
        }, () => {

          this.state.onSetFieldsValue({
            idCliente: formValues.idCliente !== 0 ? { key: formValues.idCliente } : undefined,
            idEstablecimientoCliente: formValues.idEstablecimientoCliente !== 0 ? { key: formValues.idEstablecimientoCliente } : undefined,
            documentoCliente: formValues.documentoCliente
          });
        });


        this.setState({ visibleCliente: false });
        message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
        return;
      }

      if (response.status === 400) {
        dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
        return;
      }

      dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
    });
  };


  searchTimeout = null;

  handleSearchPaises = (value, form) => {
    // Limpiar timeout anterior
    clearTimeout(this.searchTimeout);

    // No buscar si está vacío o tiene menos de 3 caracteres
    if (!value || value.trim().length < 3) {
      return;
    }

    this.searchTimeout = setTimeout(async () => {
      this.setState({ fetching: true });

      try {
        const response = await paisService.getBySearch({
          id: 0,
          value: value
        });

        if (response) {
          form.setFieldsValue({
            paises: response,
          });
        }
      } finally {
        this.setState({ fetching: false });
      }
    }, 500); // Espera 500 ms después de la última tecla
  };


  handleBuscarPadronReducido = async (idTipoDocumento, numeroDocumento, form) => {
    this.setState({ formValuesCliente: { ...this.state.formValuesCliente, searchLoading: true } });
    const response = await padronReducidoService.entidad({ idTipoDocumento, numeroDocumento });
    if (response.status === 200) {
      const provincias = await ubigeoService.provincias(response.data.idDepartamento);
      const distritos = await ubigeoService.distritos(response.data.idProvincia);
      this.setState({
        formValuesCliente: {
          ...this.state.formValuesCliente,
          searchLoading: false,
          provincias,
          distritos
        }
      }, () => {
        form.setFieldsValue({
          razonSocial: response.data.razonSocial,
          nombre: response.data.nombre,
          apellidoMaterno: response.data.apellidoMaterno,
          apellidoPaterno: response.data.apellidoPaterno,
          idCondicionSunat: { key: response.data.idCondicionSunat },
          idEstadoContribuyente: { key: response.data.idEstadoContribuyente },
          idDepartamento: { key: response.data.idDepartamento !== 0 ? response.data.idDepartamento : undefined },
          idProvincia: { key: response.data.idProvincia !== 0 ? response.data.idProvincia : undefined },
          idUbigeo: { key: response.data.idUbigeo !== 0 ? response.data.idUbigeo : undefined },
          direccion: response.data.direccion,
        });
      });
    }
    else {
      this.setState({
        formValuesCliente: {
          ...this.state.formValuesCliente,
          searchLoading: false
        }
      });
    }
  };

  handleAgregarSerie = async (row, onCalculateDetail, setFieldsValueDetalle, getFieldValueDetalle, index) => {
    debugger;
    var idAlmacen = this.state.onGetFieldValue === null ? this.state.formValues.idAlmacen : this.state.onGetFieldValue('idAlmacen').key;
    var listaSerieProducto = await movimientoService.listarSeriesDisponiblesComprobante({ idAlmacen: idAlmacen, idProducto: row.idProducto, numeroLote: row.numeroLote, idComprobante: this.state.formValues.id, idTipoComprobante: this.state.formValues.idTipoComprobante });

    this.setState({
      setFieldsValueDetalle,
      getFieldValueDetalle
    }, async () => {
      debugger;
      this.setState({
        agregarSerieVisible: true,
        agregarSerieModal: {
          ...this.state.agregarSerieModal,
          idProducto: row.idProducto,
          codigoProducto: row.codigo,
          nombreProducto: row.nombre,
          serie: '',
          listaDetalleSerie: listaSerieProducto,
          onCalculateDetail: onCalculateDetail,
          setFieldsValueDetalle: setFieldsValueDetalle,
          getFieldValueDetalle: getFieldValueDetalle,
          selectedRowKeys: row.selectedSerie,
          index: index
        }
      });

    });
  }

  handleChangeSelectedSerie = (selected, rows, onCalculateDetail, idProductoRemoveSerie, index) => {
    debugger;
    var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

    if (selected.length > 0) {
      listaComprobanteDetalle.forEach(detalle => {
        debugger;
        if (detalle.idProducto === rows[0].idProducto) {
          detalle.selectedSerie = selected;
          detalle.listaDetalleSerie = rows;
          detalle.detalleSeries = detalle.listaDetalleSerie.map(u => u.serie).join(', ');
          detalle.cantidad = detalle.listaDetalleSerie.length;
          onCalculateDetail(detalle, "arrCantidad", detalle.cantidad, 3, index);
        }
      });
    } else {
      listaComprobanteDetalle.forEach(detalle => {
        debugger;
        if (detalle.idProducto === idProductoRemoveSerie) {
          detalle.selectedSerie = [];
          detalle.listaDetalleSerie = [];
          detalle.detalleSeries = '';
          detalle.cantidad = detalle.listaDetalleSerie.length;
          onCalculateDetail(detalle, "arrCantidad", detalle.cantidad, 3, index);
        }
      });
    }

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaComprobanteDetalle: listaComprobanteDetalle,
        detalleProductos: listaComprobanteDetalle
      },
      agregarSerieModal: {
        ...this.state.agregarSerieModal,
        selectedRowKeys: selected
      }
    });
  };


  searchTimeout = null;

  handleSearchClientes = (value, form) => {
    // Limpiar timeout anterior
    clearTimeout(this.searchTimeout);

    // No buscar si está vacío o tiene menos de 3 caracteres
    if (!value || value.trim().length < 3) {
      return;
    }

    this.searchTimeout = setTimeout(async () => {
      this.setState({ fetching: true });

      try {
        const response = await clienteService.getByComprobante({
          id: 0,
          value: value,
          type: [OTROS.CODIGO, DNI.CODIGO, CARNET_EXTRANJERIA.CODIGO, RUC.CODIGO, PASAPORTE.CODIGO].join(',')
        });

        if (response) {
          form.setFieldsValue({
            clientes: response,
          });
        }
      } finally {
        this.setState({ fetching: false });
      }
    }, 500); // Espera 500 ms después de la última tecla
  };



  async componentDidMount() {
    this._isMounted = true;

    var idUsuario = auth.user().id;
    const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: VENTA });

    const datosIniciales = await comprobanteService.datosIniciales({
      idUsuario: idUsuario,
      idTipoComprobante: BOLETA_DE_VENTA.ID,
    });


    var flagSerie = configuraciones.filter((m) => m.abreviatura === VER_SERIES_VENTA).length >= 1 ? true : false;

    const serie = [undefined, null].includes(datosIniciales?.serie) ? flagSerie ? '' : '-' : datosIniciales.serie;


    this.setState({ filter: { ...this.state.filter, serie } });

    this._initPagination({ ...this.state.filter, serie }, comprobanteService.paginacion);


    //const monedas = await monedaService.listar();
    const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(
      global.fetchCurrentDateStr()
    );




    /*     const listasPrecio = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();
        const vendedores = await vendedorService.listar();
        const tiposComprobante = await tipoComprobanteService.listar();
        const detracciones = await detraccionService.listar();
        const clientes = await clienteService.listar();
    
        const tiposPersona = await tipoPersonaService.listar();
        const tiposDocumento = await tipoDocumentoService.listarExcluirPlaca();
        const condicionesSunat = await condicionSunatService.listar();
        const estadosContribuyente = await estadoContribuyenteService.listar();
        const departamentos = await ubigeoService.departamentos();
        const tiposRelacion = await tipoRelacionService.listar();
        const tiposEstablecimiento = await tipoEstablecimientoService.listar();
        const paises = await paisService.listar();
        const metodosPagos = await metodoPagoservice.listar();
        const cuentas = await cuentaService.listar(); */

    const permisosUsuario = await usuarioService.usarioEstablecimiento(auth.user().id, 1)
    const proyectos = await proyectoService.listar();


    const response = await ventasService.listar();
    const cajas = await cajaService.listarCajaAperturada(auth.user().id);

    const monedas = response.list_Moneda.result;
    const listasPrecio = response.list_Precio.result;
    const establecimientos = response.list_Establecimiento.result;
    const vendedores = response.list_Vendedor.result;
    const tiposComprobante = [];// response.list_TipoComprobante.result;
    const detracciones = [];// response.list_Detraccion.result;
    //const formasPago = response.list_FormaPago.result;
    const clientes = [];// response.list_Cliente.result;
    //const clientes_exo =clientes ? clientes.filter(m => [RUC.ID, OTROS.ID].includes(m.idTipoDocumento)) : [];

    const tiposPersona = response.list_TipoPersona.result;
    const tiposDocumento = response.list_TipoDocumento.result;

    const condicionesSunat = response.list_CondicionSunat.result;
    const estadosContribuyente = response.list_EstadoContribuyente.result;
    const departamentos = [];// response.list_Ubigeo.result;
    const tiposRelacion = response.list_TipoRelacion.result;
    const tiposEstablecimiento = response.list_TipoEstablecimiento.result;
    const paises = [];// response.list_Pais.result;

    const metodosPagos = response.list_MetodoPago.result;
    const cuentas = response.list_Cuenta.result;
    //const caja = response.list_Caja.result;
    const estado = await comprobanteService.listarEstado();
    const unidadesMedida = [];// response.list_UnidadMedida.result;
    const totaldocument = response.list_TotalComprobante.result;
    const cultivos = response.list_Cultivo.result;
    const company = response.list_Empresa;

    //const notifyExpi = await hubService.notifyExpiration({ userId: auth.user().userName, sessionId: auth.user().session });
    //const notifyStock = await hubService.NotifyStock({ userId: auth.user().userName, sessionId: auth.user().session });

    if (this._isMounted) {
      this.setState({
        loadingSource: false,
        loadingEdit: false,
        tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
        monedas: monedas ? monedas : [],
        listasPrecio: listasPrecio ? listasPrecio : [],
        establecimientos: establecimientos ? establecimientos : [],
        vendedores: vendedores ? vendedores : [],
        tiposComprobante: tiposComprobante ? tiposComprobante : [],
        detracciones: detracciones ? detracciones : [],
        clientes: clientes ? clientes : [],
        tiposPersona: tiposPersona ? tiposPersona : [],
        tiposDocumento: tiposDocumento ? tiposDocumento : [],
        condicionesSunat: condicionesSunat ? condicionesSunat : [],
        estadosContribuyente: estadosContribuyente ? estadosContribuyente : [],
        tiposRelacion: tiposRelacion ? tiposRelacion : [],
        departamentos: departamentos ? departamentos : [],
        tiposEstablecimiento: tiposEstablecimiento ? tiposEstablecimiento : [],
        paises: paises ? paises : [],
        metodosPagos: metodosPagos ? metodosPagos : [],
        cuentas: cuentas ? cuentas : [],
        caja: cajas ? cajas : [],
        estado: estado ? estado : [],
        proyectos: proyectos ? proyectos : [],
        unidadesMedida: unidadesMedida ? unidadesMedida : [],
        permisosUsuario: permisosUsuario ? permisosUsuario : [],
        configuraciones: configuraciones ? configuraciones : [],
        totaldocument: totaldocument ? totaldocument : [],
        cultivos: cultivos ? cultivos : [],
        company: company



      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Header
          title="Boleta"
          onNew={this.handleNew}
          loadingNew={this.state.loadingSource || this.state.loadingNew}
          onSearch={() => this._handlePagination(this.state.filter)}
          onClearFilters={this.handleClearFilters}
        />
        <Filters
          clientes={this.state.clientes}
          filter={this.state.filter}
          onKeyUpSearch={this.handleKeyUpInput}
          onChange={this.handleChange}
          estado={this.state.estado}
          proyectos={this.state.proyectos}
          vendedores={this.state.vendedores}
          configuraciones={this.state.configuraciones}

        />
        <ResultList
          pagination={this.state.pagination}
          loadingEdit={this.state.loadingEdit || this.state.loadingSource}
          loadingCopy={this.state.loadingCopy || this.state.loadingSource}
          loadingVer={this.state.loadingVer}
          loadingExcel={this.state.loadingExcel}
          loadingPdf={this.state.loadingPdf}
          loadingImprimir={this.state.loadingImprimir || this.state.loadingSource}
          loadingEmitir={this.state.loadingEmitir || this.state.loadingSource}
          loadingCorreo={this.state.loadingCorreo}
          claim={this.state.company?.idTipoEmpresa === 2}
          flagEmpresaTaller={this.state.company?.idTipoEmpresa === 5}
          onExportExcel={this.handleExportExcel}
          onExportPdf={this.handleExportPdf}
          onPrint={this.handlePrint}
          onEdit={this.handleEdit}
          onCopy={this.handleCopy}
          onChange={this._handleChangePagination}
          onView={this.handleView}
          onEmitir={this.handleOpenEmitirModal}
          onAnular={this.handleAnular}
          onImprimir={this.handleImprimir}
          onCorreo={this.handleCorreo}
          onCdr={this.handleOpenCdrModal}
          onBtnCopy={this.state.filter.idTipoComprobante}
          onTipoFilter={1}

        />
        <FormModal
          visible={this.state.visible}
          formValues={this.state.formValues}
          saveLoading={this.state.saveLoading}
          onBuscarCliente={this.handleBuscarCliente}
          onAgregarDetalle={this.handleAgregarDetalle}
          onRemoverProducto={this.handleRemoverProducto}
          onRemoverReferencia={this.handleRemoverReferencia}
          onEditarNombreProducto={this.handleEditarNombreProducto}
          onChangeTab={this.handleChangeTab}
          onChange={this.handleChangeForm}
          onImportarPedido={this.handleImportarPedido}
          onImportarCotizacion={this.handleImportarCotizacion}
          onImportarGuiaRemision={this.handleImportarGuiaRemision}
          onClose={() => this.setState({ visible: false })}
          onImportarAnticipo={this.handleImportarAnticipo}
          onAnticipo={this.handleAnticipo}
          onSave={this.handleSave}
          onScanerProduct={this.handleScaner}
          onNewCliente={this.handleNewCliente}
          onRemoverMetodoPago={this.handleRemoverMetodoPago}
          onAgregarSerie={this.handleAgregarSerie}
          isPendienteSi={this.state.isPendienteSi}
          onCalculateMetodoPago={this.onCalculateMetodoPago}
          OnItemLibre={this.handleItemLibre}
          CalculateDescuento={this.calculateDescuento}
          handleSelectConversion={this.handleSelectConversion}
          configuraciones={this.state.configuraciones}
          fetchClientes={this.handleSearchClientes}
          fetching={this.state.fetching}

        />
        <SearchProductModal
          onBuscarProducto={this.handleBuscarProducto}
          visible={this.state.searchProductVisible}
          validarStock={this.state.searchProductFormValues.validarStock}
          dataSource={this.state.searchProductFormValues.dataSource}
          precioUnitInclyIGV={this.state.searchProductFormValues.precioUnitInclyIGV}
          loadingProduct={this.state.loadingProduct}
          dataSourceAgregado={this.state.formValues.listaComprobanteDetalle}
          onSelect={this.handleSelectProduct}
          onCancel={() => this.setState({ searchProductVisible: false })}
        />
        <EditarNombreProductoModal
          visible={this.state.editarNombreProductoVisible}
          formValues={this.state.editarNombreProductoFormValues}
          onClose={() => this.setState({ editarNombreProductoVisible: false })}
          onSave={this.handleSaveEditarNombreProducto}
        />
        <EmitirModal
          visible={this.state.emitirVisible}
          file={this.state.emitirFilePdf}
          onEmitir={this.handleEmitir}
          onClose={() => this.setState({ emitirVisible: false })}
        />
        <ImprimirModal
          visible={this.state.imprimirVisible}
          formValues={this.state.imprimirFormValues}
          onChange={this.handleChangeImprimir}
          onSwitch={this.handleSwitch}
          onDownload={this.handleDownloadPdf}
          onClose={() => this.setState({ imprimirVisible: false })}
        />
        <CorreoModal
          visible={this.state.correoVisible}
          formValues={this.state.correoFormValues}
          onChange={this.handleChangeCorreo}
          onClose={() => this.setState({ correoVisible: false })}
          onSend={this.handleEnviarCorreo}
        />
        <CdrModal
          visible={this.state.cdrVisible}
          loadingFile={this.state.loadingFile}
          item={this.state.selectedItem}
          onDownloadXml={this.handleDownloadXml}
          onDownloadCdr={this.handleDownloadCdr}
          onGetCdr={this.handleGetCdr}
          onClose={() => this.setState({ cdrVisible: false })}
        />
        <ViewModal
          visible={this.state.viewVisible}
          formValues={this.state.viewFormValues}
          onClose={() => this.setState({ viewVisible: false })}
        />
        <ImportarModal
          tittle="Búsqueda de Pedido"
          visible={this.state.importarVisible}
          formValues={this.state.importarFormValues}
          dataSource={this.state.importarFormValues.dataSource}
          onSelect={this.handleSelectPedido}
          onClose={() => this.setState({ importarVisible: false })}
        />
        <ImportarModalCotizacion
          tittle="Búsqueda de Cotización"
          visible={this.state.importarCotizacionVisible}
          formValues={this.state.importarCotizacionFormValues}
          onSelect={this.handleSelectCotizacion}
          onClose={() => this.setState({ importarCotizacionVisible: false })}
        />

        <ImportarModalAnticipo
          tittle="Búsqueda de Anticipo"
          visible={this.state.importarAnticipoVisible}
          formValues={this.state.importarAnticipo}
          onSelect={this.handleSelectAnticipo}
          onClose={() => this.setState({ importarAnticipoVisible: false })}
        />

        <ImportarModalGuia
          tittle="Búsqueda de Guía de Remisión"
          visible={this.state.importarGuiaRemisionVisible}
          formValues={this.state.importarGuiaRemision}
          onSelect={this.handleSelectGuiaRemision}
          onClose={() => this.setState({ importarGuiaRemisionVisible: false })}
        />

        <FormModalCliente
          visible={this.state.visibleCliente}
          formValues={this.state.formValuesCliente}
          onChange={this.handleChangeFormCliente}
          onBuscarPadronReducido={this.handleBuscarPadronReducido}
          onClose={() => this.setState({ visibleCliente: false })}
          onSave={this.handleSaveCliente}
          fetchPaises={this.handleSearchPaises}
          fetching={this.state.fetching}
        />

        <AgregarSerieModal
          visible={this.state.agregarSerieVisible}
          formValues={this.state.agregarSerieModal}
          onCancel={() => this.setState({ agregarSerieVisible: false })}
          onAgregarSerieDetalle={this.handleChangeSelectedSerie}
          onRemove={this.handleRemoverSerieDetalle}
        />

      </div>
    );
  }
}
